/* design—light · dl-cart.js — room-board cart + drawer + share + print + draft-order popup.
   Rooms = line item property "Místnost" (immutable per line -> re-assign = add new line + remove old; Shopify then merges identical variant+plan+room lines natively).
   Room sequence = cart attribute "Místnosti" (names joined by |). Display order = attribute "Pořadí" (line keys joined by ,).
   NOTE deploy: upload as TEXT — base64 truncates at this size. Verify checksumMd5 after every push,
   and keep this file free of \\uXXXX escapes; literal escapes are what fail to survive transcription. */
(function(){
'use strict';
var root=document.getElementById('dlk');
var conf=window.DLK_CONF||{};
var D=root?root.dataset:{};
var ORD_MIN=+(D.orderMin||2000000),ORD_MAND=+(D.orderMandatory||8000000);
var FREE=+(D.freeShip||500000),SHIP_FROM=+(D.shipFrom||12900);
var PLAN=D.sellingPlan||'',PRE_PCT=+(D.preorderPct||8);
var PRESETS=(D.presets||'').split('|').filter(Boolean);
var SHOWROOM=D.showroomLabel||'';
var CART=null,PRODUCTS={},INFLIGHT={},rexp={},busy=false,cartFresh=false;
var nf=new Intl.NumberFormat('cs-CZ',{style:'currency',currency:conf.currency||'CZK',maximumFractionDigits:0});
var fmt=function(c){return nf.format(c/100);};
var plural=function(n){return n===1?'1 položka':(n>=2&&n<=4?n+' položky':n+' položek');};
var $=function(s,r){return(r||document).querySelector(s);};
var esc=function(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');};
/* brand marks — window.DLK_BRANDS is server-rendered by dl-cart.liquid as
   {downcased collection title: logo url} for the brand collections carrying a custom.logo
   metafield. Vendors without one (OSRAM, PHILIPS, TESLA…) are simply absent from the map and
   keep the uppercase text. Both sides are lowercased and trimmed because vendor strings and
   collection titles are maintained in different admin screens ("Ingo Maurer" vs "INGO MAURER").
   The .brl box height is pinned in dl-cart.css to the text line it replaces, so nothing shifts.

   TWO PASSES, EXACT THEN PREFIX (2026-08-10) — mirrors snippets/dl-brandmark.liquid, which does
   the same job server-side for product cards and the no-JS cart. Pass 1 is the exact key hit and
   always wins. Pass 2 runs only when pass 1 misses, and takes the first key that is a *prefix* of
   the downcased vendor — a brand's collection title is often shorter than the vendor strings its
   products carry: key "vitae" vs vendors "Vitae LAB" and "Vitaelight", neither equal to "vitae".
   Checked against all 29 store vendors; the prefix pass changes exactly three:
     Vitae LAB                       -> vitae     (intended)
     Vitaelight                      -> vitae     (intended)
     Artemide Konfigurator Komponenty -> Artemide  (deliberate: these are Artemide parts)
   Backend, BaseLine, BLV, DURA, GE, IONNYK, LESSEM, MEGAMAN, NARVA, Osmont, OSRAM, PANLUX,
   PHILIPS, RADIUM, SYLVANIA, TESLA, InkPoster and design-light all still fall through to text.
   The match is anchored at index 0, so a short key can never match a vendor it is merely inside.

   brandHit returns the matched key alongside the url so both renderers can stamp
   data-brand="<key>" on the <img>; that hook is what lets one brand be nudged in CSS without
   hard-coding anything else (see the GRAU height rule in dl-cart.css). 2026-08-09/2026-08-10 */
var brandHit=function(v){
 var m=window.DLK_BRANDS;if(!m)return null;
 var k=String(v==null?'':v).toLowerCase().trim();if(!k)return null;
 var own=function(o,p){return Object.prototype.hasOwnProperty.call(o,p);};
 if(own(m,k)&&m[k])return{src:m[k],key:k};
 for(var t in m){if(own(m,t)&&t&&m[t]&&k.indexOf(t)===0)return{src:m[t],key:t};}
 return null;};
var brandImg=function(h,v){return '<img class="brl" src="'+esc(h.src)+'" alt="'+esc(v)+'" data-brand="'+esc(h.key)+'" loading="lazy">';};
var brandMark=function(v){var h=brandHit(v);return h?brandImg(h,v):'<span class="br">'+esc(v)+'</span>';};
/* the drawer deliberately has no text fallback: those rows never carried a brand line at all,
   so printing "OSRAM" there would be new clutter, not a fix. Logo where we have one, or nothing. */
var brandMarkOnly=function(v){var h=brandHit(v);return h?brandImg(h,v):'';};
var ROOM_KEY='Místnost',ROOMS_ATTR='Místnosti',ORDER_ATTR='Pořadí';
var SW={'bílá':'#ffffff','černá':'#1a1916','přírodní':'#d9c9a8','jantarová':'#e0a13c','růžová':'#e5a4b8','modrá':'#3a5fa8','zelená':'#3f7a4e','kouřová':'#9a9a9a','grafitová':'#48484a','rubínová':'#8e1f2f','zlatá':'#c9a227','třešeň':'#7a3b2e','dub':'#c49a6c','ořech':'#6b4a2f','pergamen':'#eae2cf','satén':'#e3e3e0','leštěný hliník':'#c9ccd1','mosaz':'#b5893a','měď':'#b3653f','chrom':'#cfd2d6','nikl':'#b9bcbd','bronz':'#7d5a3c','šedá':'#8d8d8d','béžová':'#d9cdb8','krémová':'#efe8d8','terakota':'#b0563b','hnědá':'#6f4e37'};
/* ---------- slevové kódy vs. předobjednávková cena (2026-09-03) ----------
   Pravidlo (Hynek): kód se NIKDY nemá sčítat s předobjednávkovou slevou nad danou hranici.
   Pod hranicí (výchozí 9 %) se kód sečte — 8 % čekání + 8 % kód dá 15,4 %, ne 16 %, protože
   Shopify počítá kód z ceny PO plánu. Od hranice výš se řádky přepnou na předobjednávkový plán
   BEZ slevy, takže se kód počítá z plné ceny a nic se nekombinuje.

   Proč přepnout plán a ne ho sundat: plán nese `reserve: ON_FULFILLMENT`, tedy „nesahá na skladem
   dostupné kusy". Sundat plán = z předobjednávky se stane běžný prodej, který zásobu odepíše.
   Plán se tedy vyměňuje za sourozence bez cenové úpravy, ne ruší.

   Kód aplikujeme přes /cart/update.js {discount:'KÓD'} a jeho skutečnou hodnotu čteme až ZPĚTNĚ
   z odpovědi — procenta kódu dopředu neznáme a znát nemůžeme. Počítá se per řádek z
   `line_level_total_discount`, takže kódy omezené jen na některé produkty (jako NAB-*) vyjdou
   správně. */
var CODE_MIN=+(D.codeThreshold||9),FULL_PLAN=(D.fullPlan||'').trim();
function codeList(){return (CART&&CART.discount_codes)||[];}
function liveCode(){return codeList().filter(function(c){return c.applicable;})[0]||null;}
function deadCode(){return codeList().filter(function(c){return !c.applicable;})[0]||null;}
/* nominální % kódu na řádku: sleva / cena, ze které se počítala */
function lineCodePct(l){
 var d=+(l.line_level_total_discount||0);if(!d)return 0;
 var base=(+l.final_line_price||0)+d;
 return base?(d/base)*100:0;
}
function cartCodePct(){
 var d=0,base=0;
 (CART.items||[]).forEach(function(l){
  var x=+(l.line_level_total_discount||0);d+=x;base+=(+l.final_line_price||0)+x;
 });
 return base?(d/base)*100:0;
}
/* Na který plán řádek přepnout. Skupiny 5/8/12 % budou mít každá svého sourozence bez slevy,
   proto se ptáme per produkt; nastavení `full_plan_id` je jen záložní hodnota pro hlavní skupinu. */
function targetFullPlanId(l){
 var f=fullPlanFor(l);
 return (f&&f.id)||FULL_PLAN||null;
}
/* Řádky, které kód nutí přepnout. Pozor: s aplikovaným kódem je `final_price` už snížená, takže
   „je na plné ceně?" NELZE poznat z ceny — porovnává se identita plánu. */
function linesToSwitch(pct){
 if(pct<CODE_MIN)return [];
 return (CART.items||[]).filter(function(l){
  if(!lineIsPre(l))return false;
  var cur=l.selling_plan_allocation.selling_plan.id,t=targetFullPlanId(l);
  return !t||+cur!==+t;
 });
}
/* ---------- alternatives = the "quantity 0" tiles (2026-09-02) ----------
   Shopify cannot hold a line at quantity 0: posting 0 DELETES the line, and a line parked at
   quantity 1 with a hidden property would still be a payable line — one /checkout reached outside
   our own button and the client buys a lamp nobody picked. So a 0-qty tile is deliberately NOT a
   cart line. It is a record in the cart attribute `Alternativy`.

   What that buys us, and the reason it was chosen over a hidden line:
     · cart.total_price, item_count, final_line_price, the free-shipping bar and every room subtotal
       stay Shopify's own numbers. Nothing is recomputed by hand, so no arithmetic of ours can ever
       put a wrong price in front of a customer.
     · an alternative is structurally incapable of reaching an order. Not "blocked" — absent.

   Record: variantId,handle,encodeURIComponent(room),sellingPlanId   ·   records joined by |
   encodeURIComponent escapes both `,` and `|`, so a room name may contain either. An empty third
   field means Nezařazeno; an empty fourth means Skladem. Record ORDER is display order within a
   room, and the array index is the tile's handle for promote/remove — stable for one render pass,
   which is all it has to be, because render() rebuilds from the attribute every time. */
var ALT_ATTR='Alternativy';
var ALT_MAX=4000;   /* attribute payload ceiling; Pořadí already runs ~1 kB live without complaint */
function alts(){
 return String(CART&&CART.attributes?CART.attributes[ALT_ATTR]||'':'').split('|').filter(Boolean)
  .map(function(s,i){
   var f=s.split(',');
   return {i:i,vid:+f[0],handle:f[1]||'',room:f[2]?decodeURIComponent(f[2]):null,plan:f[3]||''};
  }).filter(function(a){return a.vid&&a.handle;});
}
function altStr(list){
 return list.map(function(a){
  return [a.vid,a.handle,a.room?encodeURIComponent(a.room):'',a.plan||''].join(',');
 }).join('|');
}
/* Buckets alternatives exactly the way render() buckets lines: a named room takes its exact
   matches, and Nezařazeno takes both the roomless AND the orphans — records naming a room that no
   longer exists, which is what a share link built before a room was renamed hands us. Without the
   orphan clause such a record is invisible yet still locks the checkout button. */
function altsIn(room){
 if(room)return alts().filter(function(a){return a.room===room;});
 var rs=rooms();
 return alts().filter(function(a){return !a.room||rs.indexOf(a.room)<0;});
}
function altAttr(list){var a={};a[ALT_ATTR]=altStr(list);return a;}
function saveAlts(list){return updateAttrs(altAttr(list));}
/* ---------- cart IO ---------- */
function getCart(){return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){CART=c;cartFresh=true;return c;});}
function post(url,body){
 return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
  .then(function(r){if(!r.ok)return r.json().then(function(e){throw e;});return r.json();});
}
function change(key,qty,props){var b={id:key,quantity:qty};if(props)b.properties=props;return post('/cart/change.js',b).then(function(c){CART=c;cartFresh=true;return c;});}
function updateAttrs(attrs){return post('/cart/update.js',{attributes:attrs}).then(function(c){CART=c;cartFresh=true;return c;});}
function addItem(it){cartFresh=false;return post('/cart/add.js',{items:[it]});}
function productFor(line){
 var h=line.handle||line.url.split('?')[0].split('/').pop();
 if(PRODUCTS[h])return Promise.resolve(PRODUCTS[h]);
 if(INFLIGHT[h])return INFLIGHT[h];
 try{var c=sessionStorage.getItem('dlk-p-'+h);if(c){PRODUCTS[h]=JSON.parse(c);return Promise.resolve(PRODUCTS[h]);}}catch(x){}
 INFLIGHT[h]=fetch((conf.root||'/')+'products/'+h+'.js').then(function(r){return r.json();})
  .then(function(p){PRODUCTS[h]=p;delete INFLIGHT[h];try{sessionStorage.setItem('dlk-p-'+h,JSON.stringify(p));}catch(x){}return p;})
  .catch(function(){delete INFLIGHT[h];return null;});
 return INFLIGHT[h];
}
function imgUrl(u,w){return u?u+(u.indexOf('?')>=0?'&':'?')+'width='+w+'&height='+w+'&crop=center':'';}
/* ---------- state helpers ---------- */
function rooms(){return String(CART.attributes[ROOMS_ATTR]||'').split('|').filter(Boolean);}
function orderedLines(){
 var keys=String(CART.attributes[ORDER_ATTR]||'').split(',').filter(Boolean);
 var ls=CART.items.slice();
 ls.sort(function(a,b){
  var ia=keys.indexOf(a.key),ib=keys.indexOf(b.key);
  if(ia<0&&ib<0)return 0;if(ia<0)return 1;if(ib<0)return -1;return ia-ib;
 });
 return ls;
}
function roomOf(l){return l.properties&&l.properties[ROOM_KEY]?l.properties[ROOM_KEY]:null;}
function saveOrder(ls){return updateAttrs((function(a){a[ORDER_ATTR]=ls.map(function(l){return l.key;}).join(',');return a;})({}));}
function lineIsPre(l){return !!l.selling_plan_allocation;}
function unitCompare(l){return lineIsPre(l)&&l.original_price>l.final_price?l.original_price:0;}
/* ---------- share link ---------- */
function buildShareLink(){
 var qs=[];
 orderedLines().forEach(function(l){
  qs.push('items[][id]='+l.variant_id);
  qs.push('items[][quantity]='+l.quantity);
  if(lineIsPre(l))qs.push('items[][selling_plan]='+l.selling_plan_allocation.selling_plan.id);
  var r=roomOf(l);
  if(r)qs.push('items[][properties]['+encodeURIComponent(ROOM_KEY)+']='+encodeURIComponent(r));
 });
 var next=conf.cartUrl||'/cart';
 var rs=rooms(),as=altStr(alts());
 /* Both rooms and alternatives ride in the same /cart/update step. The alternatives payload is
    already percent-encoded per room name; encodeURIComponent here escapes those % signs a second
    time and the URL parser peels exactly one layer back off, so the stored string round-trips. */
 var ap=[];
 if(rs.length)ap.push('attributes['+encodeURIComponent(ROOMS_ATTR)+']='+encodeURIComponent(rs.join('|')));
 if(as)ap.push('attributes['+encodeURIComponent(ALT_ATTR)+']='+encodeURIComponent(as));
 if(ap.length)next='/cart/update?'+ap.join('&')+'&return_to='+encodeURIComponent(conf.cartUrl||'/cart');
 /* a board that is nothing but alternatives has no items to add — /cart/add with an empty query
    is an error page, so skip that hop entirely and let /cart/update do the work */
 var dest=qs.length?'/cart/add?'+qs.join('&')+'&return_to='+encodeURIComponent(next):next;
 return location.origin+'/cart/clear?return_to='+encodeURIComponent(dest);
}
window.DLK_shareLink=buildShareLink;
/* ---------- mutations (re-add pattern: properties are immutable per line) ---------- */
/* Undo for the alternatives bulk-remove. It survives exactly one cart mutation — the one that
   created it — and any other action clears it, which is what "until you do something else" means.
   Every mutation in this file funnels through relines(), so this is the one place to expire it. */
var UNDO=null,UNDOKEEP=false;
function setUndo(list){UNDO={list:list,n:list.length};UNDOKEEP=true;}
function relines(fn,key){
 if(busy)return;busy=true;cartFresh=false;
 if(UNDOKEEP)UNDOKEEP=false;else UNDO=null;
 var el=key&&root?root.querySelector('.cline[data-key="'+String(key).replace(/"/g,'\\"')+'"]'):null;
 if(el)el.classList.add('lbusy');else if(root)root.classList.add('busy');
 /* FIX 2026-08-11: the recovery .catch below itself calls render(), so it can reject too.
    The trailing cleanup .then() is fulfillment-only, so such a second rejection skipped it
    and left busy=true forever — every later cart interaction was then silently dropped
    until a page reload. The added ['catch'] swallows any rejection from the recovery path
    so the cleanup ALWAYS runs: the busy flag must never be left set. */
 fn().then(function(){return cartFresh?null:getCart();}).then(function(){render();}).catch(function(e){
  toast((e&&e.description)||'Akci se nepodařilo provést');return getCart().then(render);
 })['catch'](function(){}).then(function(){busy=false;if(root){root.classList.remove('busy');root.querySelectorAll('.lbusy').forEach(function(x){x.classList.remove('lbusy');});}});
}
/* PERF (2026-08-08): the fast path. /cart/change.js accepts `properties` and `selling_plan` and
   keeps the line's position, so a room switch or a Skladem/Počkám switch is ONE round trip instead
   of add + remove + reorder (three, ~2.4 s measured on live; this is ~0.6 s).
   Two Shopify behaviours this leans on, both verified live before it was written:
     · `properties` REPLACES the whole property bag — it does not merge. So we always resend every
       existing key, or a Poznámka from the product page would be silently dropped.
     · a properties-only change leaves an existing selling plan allocation intact.
   Only usable when the variant is not changing; setVariant still goes through readd(). */
function inPlace(l,over){
 var b={id:l.key};
 if(over.quantity!=null)b.quantity=over.quantity;
 if('room'in over){
  var p={},k;
  for(k in (l.properties||{}))if(k!==ROOM_KEY)p[k]=l.properties[k];
  p[ROOM_KEY]=over.room||'';
  b.properties=p;
 }
 /* planId names an exact plan and wins over `pre` — the promo-code rule needs to move a line onto
    the full-price pre-order plan specifically, not just "whatever Počkám means here". */
 if('planId'in over){
  if(!over.planId)return Promise.reject({description:'Plán není u tohoto produktu dostupný'});
  b.selling_plan=over.planId;
 }else if('pre'in over){
  if(over.pre){
   var pid=lineIsPre(l)?l.selling_plan_allocation.selling_plan.id:(planFor(l)&&planFor(l).id);
   if(!pid)return Promise.reject({description:'Předobjednávka není u tohoto produktu dostupná'});
   b.selling_plan=pid;
  }else b.selling_plan=null;
 }
 var oldKey=l.key,prev={};
 CART.items.forEach(function(x){prev[x.key]=1;});
 return post('/cart/change.js',b).then(function(c){
  CART=c;cartFresh=true;
  /* A property or selling-plan change RE-KEYS the line (the key is a hash of variant + properties),
     so Pořadí still points at the dead key and orderedLines() would drop the tile to the end and
     slowly corrupt the manual up/down ordering. Patch the order locally so the very next render is
     already right, then persist it on a debounce — the user never waits for that write. */
  var nk=null,i;
  for(i=0;i<c.items.length;i++){if(!prev[c.items[i].key]){nk=c.items[i].key;break;}}
  if(nk&&nk!==oldKey){
   var keys=String(c.attributes[ORDER_ATTR]||'').split(',').filter(Boolean);
   var at=keys.indexOf(oldKey);
   if(at>=0){keys[at]=nk;c.attributes[ORDER_ATTR]=keys.join(',');persistOrderSoon();}
  }
  return c;
 });
}
/* Pořadí is display-only, so it does not need to be written inside the interaction. One debounced
   write covers a burst of edits, and pagehide flushes it if the visitor leaves first. */
var orderTimer=0;
function orderBody(){var a={};a[ORDER_ATTR]=String((CART&&CART.attributes&&CART.attributes[ORDER_ATTR])||'');return {attributes:a};}
function persistOrderSoon(){
 clearTimeout(orderTimer);
 orderTimer=setTimeout(function(){orderTimer=0;post('/cart/update.js',orderBody())['catch'](function(){});},500);
}
addEventListener('pagehide',function(){
 if(!orderTimer)return;
 clearTimeout(orderTimer);orderTimer=0;
 try{navigator.sendBeacon('/cart/update.js',new Blob([JSON.stringify(orderBody())],{type:'application/json'}));}catch(e){}
});
function readd(l,over){
 /* ADD FIRST, remove after success — a 422 must never lose the line (deploy review blocker 1) */
 var it={id:over.variant_id||l.variant_id,quantity:over.quantity!=null?over.quantity:l.quantity,properties:{}};
 var r=('room'in over)?over.room:roomOf(l);
 if(r)it.properties[ROOM_KEY]=r;
 var pre=('pre'in over)?over.pre:lineIsPre(l);
 if(pre){var pid=lineIsPre(l)?l.selling_plan_allocation.selling_plan.id:(planFor(l)&&planFor(l).id);if(pid)it.selling_plan=pid;}
 var oldKey=l.key;
 /* PERF (2026-08-08): the removal and the position fix ride in one /cart/update.js — it takes line
    keys in `updates` and `attributes` in the same body (verified live). Three calls became two. */
 var live={};CART.items.forEach(function(x){live[x.key]=1;});
 var keys=String(CART.attributes[ORDER_ATTR]||'').split(',').filter(Boolean);
 return addItem(it).then(function(added){
  /* /cart/add.js answers {items:[line]} for the array form — NOT a bare line item. Reading .key off
     the wrapper yields undefined, which silently skipped the reorder and left Pořadí pointing at the
     replaced line's dead key. Accept both shapes. */
  var nk=added&&(added.key||(added.items&&added.items[0]&&added.items[0].key));
  var body={updates:{}};body.updates[oldKey]=0;
  if(keys.length&&nk){
   var out=[],placed=false;
   keys.forEach(function(k){
    if(k===oldKey){out.push(nk);placed=true;}
    else if(k!==nk&&live[k])out.push(k);
   });
   if(!placed)out.push(nk);
   var a={};a[ORDER_ATTR]=out.join(',');body.attributes=a;
  }
  return post('/cart/update.js',body).then(function(c){CART=c;cartFresh=true;return c;});
 });
}
/* per-product selling plans, emitted by dl-cart.liquid as window.DLK_PLANS={product_id:[{id,name}]} */
/* deep-link to the product page carrying the line key, so the page can offer replace/add */
function editUrl(l){var u=l.url||'';return u+(u.indexOf('?')>=0?'&':'?')+'dlk='+encodeURIComponent(l.key);}
function optName(o){return o&&typeof o==='object'?(o.name||o.title||''):(o||'');}
/* DLK_PLANS is server-rendered from the cart Liquid, so a product added by the quick-add search
   is not in it. seedPlans() fills it from the product JSON we already fetch, which keeps the
   Počkám price on a freshly added line instead of waiting for a page reload. */
function seedPlans(p){
 if(!p||!p.id)return null;
 var m=window.DLK_PLANS||(window.DLK_PLANS={});
 if(m[p.id]&&m[p.id][0])return m[p.id][0];
 var g=(p.selling_plan_groups||[])[0],ps=(g&&g.selling_plans)||[];
 var out=ps.map(function(x){return {id:x.id,name:x.name};});
 if(!out.length){
  /* older product JSON omits selling_plan_groups — fall back to the variant allocation */
  var a=null;
  (p.variants||[]).some(function(v){a=(v.selling_plan_allocations||[])[0];return !!a;});
  if(a&&a.selling_plan_id)out=[{id:a.selling_plan_id,name:'Počkám na příští objednávku'}];
 }
 m[p.id]=out;
 return out[0]||null;
}
/* ---------- which selling plan is which (2026-09-03) ----------
   Until now every group held exactly ONE plan, so `[0]` was always the right answer. A second,
   FULL-PRICE pre-order plan is coming (it lets a promo code be computed from the full price while
   the line keeps its PRE_ORDER / reserve:ON_FULFILLMENT behaviour, so the order still doesn't
   touch on-hand stock). The moment that plan exists, `[0]` becomes a coin flip: Shopify does not
   promise the order of `selling_plans`, and drawing the wrong one would quietly price "Počkám" at
   full price across 800 products without erroring anywhere.

   So decide by PRICE, never by position and never by name: the discount plan is the one whose
   allocation costs LESS than the variant; the full-price plan is the one that costs the SAME.
   Names and positions are editable in the admin; the price relationship is the actual meaning.
   Until the product JSON has loaded there are no allocations to compare, and the historical
   answer (`[0]`) is kept — with one plan in the group that is still exactly correct. */
function variantOf(l){
 var p=PRODUCTS[l.handle];
 return p&&p.variants?p.variants.find(function(x){return x.id===l.variant_id;}):null;
}
function pickPlan(l,wantFull){
 var list=(window.DLK_PLANS&&window.DLK_PLANS[l.product_id])||[];
 if(!list.length)return null;
 var v=variantOf(l),allocs=(v&&v.selling_plan_allocations)||[];
 if(v&&allocs.length){
  for(var i=0;i<list.length;i++){
   var a=allocs.filter(function(x){return +x.selling_plan_id===+list[i].id;})[0];
   if(!a)continue;
   if((+a.price>=+v.price)===!!wantFull)return list[i];
  }
  /* allocations known and none matched: the asked-for kind genuinely is not offered here */
  return null;
 }
 return wantFull?null:list[0];
}
function planFor(l){
 var q=pickPlan(l,false);if(q)return q;
 var p=PRODUCTS[l.handle];
 if(p){seedPlans(p);q=pickPlan(l,false);if(q)return q;}
 return null;
}
/* the wait-at-full-price plan, or null where the product does not offer one */
function fullPlanFor(l){return pickPlan(l,true);}
/* position is preserved by readd() itself now — it folds the Pořadí rewrite into the same
   /cart/update.js that removes the old line, so the standalone fixOrder() round trip is gone. */
function setQty(key,qty){relines(function(){return change(key,qty);});}
/* the stepper is the most-clicked control — paint first, talk to Shopify after */
var qpend={},qtimer;
function bumpQty(key,delta,noPark){
 var l=CART.items.find(function(x){return x.key===key;});if(!l)return;
 var n=(qpend[key]!=null?qpend[key]:l.quantity)+delta;
 /* CHANGED 2026-09-02: on the cart board, − at 1 no longer deletes the line silently — it parks it
    as an alternative, a different operation with a different round trip, so it leaves the debounce
    path here rather than falling through to flushQty with a 0.
    noPark keeps the OLD behaviour for the drawer. The drawer is a mini-cart: no rooms, no place to
    show an alternative, so a parked line would simply vanish from it with no trace. It also hosts
    dl-cartplus.js's quantity dialog, whose 0 is an explicit button reading „Odebrat z košíku" —
    that promise has to keep meaning removal. Parking is a cart-page gesture only. */
 if(n<1){delete qpend[key];if(noPark)setQty(key,0);else demote(key);return;}
 qpend[key]=n;
 document.querySelectorAll('[data-key="'+key.replace(/"/g,'\\"')+'"] .qty span').forEach(function(el){el.textContent=n;});
 clearTimeout(qtimer);qtimer=setTimeout(flushQty,400);
}
function flushQty(){
 var keys=Object.keys(qpend);if(!keys.length||busy)return;
 var m=qpend;qpend={};
 /* PERF (2026-08-08): one /cart/update.js for every pending line, instead of a sequential
    /cart/change.js per line — N round trips became 1. */
 relines(function(){
  var u={};keys.forEach(function(k){u[k]=m[k];});
  return post('/cart/update.js',{updates:u}).then(function(c){CART=c;cartFresh=true;return c;});
 });
}
/* ---------- alternatives: the four state changes ----------
   demote  line  -> record   (− pressed at quantity 1)
   promote record -> line    (+ pressed on a 0-qty tile)
   dropAlt record -> gone    (Odebrat on one tile)
   clearAlts      -> gone    (Odebrat nulové položky, all of them, confirmed, undoable) */
function demote(key){
 var l=CART.items.find(function(x){return x.key===key;});if(!l||busy)return;
 var list=alts();
 var rec={vid:l.variant_id,handle:l.handle||l.url.split('?')[0].split('/').pop(),
          room:roomOf(l),plan:lineIsPre(l)?String(l.selling_plan_allocation.selling_plan.id):''};
 if(altStr(list.concat([rec])).length>ALT_MAX){toast('Nulových položek je už příliš mnoho, část jich odeberte');return;}
 /* Any quantities still waiting on the 400 ms debounce ride along in the same /cart/update.js.
    Without this they would be dropped: flushQty bails while busy, and its timer is gone. */
 var pend=qpend;qpend={};clearTimeout(qtimer);
 /* optimistic: the tile greys out and reads 0 on the click, the network catches up after */
 var tile=root&&root.querySelector('.cline[data-key="'+String(key).replace(/"/g,'\\"')+'"]');
 if(tile){tile.classList.add('gh');var qs=tile.querySelector('.qty span');if(qs)qs.textContent='0';}
 relines(function(){
  var u={};Object.keys(pend).forEach(function(k){u[k]=pend[k];});u[key]=0;
  var a=altAttr(list.concat([rec]));
  /* the line key dies with the line; leaving it in Pořadí is harmless but it accumulates */
  a[ORDER_ATTR]=String(CART.attributes[ORDER_ATTR]||'').split(',').filter(function(k){return k&&k!==key;}).join(',');
  return post('/cart/update.js',{updates:u,attributes:a}).then(function(c){CART=c;cartFresh=true;return c;});
 },key);
}
function promote(i){
 var list=alts(),rec=list[i];if(!rec||busy)return;
 relines(function(){
  var it={id:rec.vid,quantity:1,properties:{}};
  if(rec.room)it.properties[ROOM_KEY]=rec.room;
  if(rec.plan)it.selling_plan=+rec.plan;
  /* add first, drop the record only once Shopify has accepted the line — a sold-out variant
     rejects here and the alternative must survive that, not vanish into neither state */
  return addItem(it).then(function(){
   return saveAlts(list.filter(function(x,j){return j!==i;}));
  });
 });
}
function dropAlt(i){
 var list=alts();if(!list[i]||busy)return;
 setUndo(list);
 relines(function(){return saveAlts(list.filter(function(x,j){return j!==i;}));});
}
function clearAlts(){
 var list=alts();if(!list.length||busy)return;
 setUndo(list);
 relines(function(){return saveAlts([]);});
}
function undoAlts(){
 if(!UNDO||busy)return;
 var list=UNDO.list;UNDO=null;UNDOKEEP=true;
 relines(function(){return saveAlts(list);});
}
function setAltRoom(i,room){
 var list=alts(),rec=list[i];if(!rec||busy)return;
 if((rec.room||null)===(room||null))return;
 var isNew=!!room&&rooms().indexOf(room)<0;
 list[i]={i:i,vid:rec.vid,handle:rec.handle,room:room||null,plan:rec.plan};
 relines(function(){
  var a=altAttr(list);
  if(isNew){var rs=rooms();rs.push(room);a[ROOMS_ATTR]=rs.join('|');}
  return updateAttrs(a);
 });
}
/* ---------- kód: aplikace, vyhodnocení, přepnutí ----------
   Postup je vždy: aplikuj → přečti skutečnou slevu → teprve pak rozhodni. Procenta kódu se
   dopředu zjistit nedají, storefront je nezná. */
function postCode(code){
 return post('/cart/update.js',{discount:code}).then(function(c){CART=c;cartFresh=true;return c;});
}
function clearCode(){
 if(busy)return;
 CODEPEND=null;
 relines(function(){return postCode('');});
}
var CODEPEND=null;   /* {code, pct, lines, nowTotal, switchedTotal} čekající na potvrzení */
function applyCode(code){
 code=(code||'').trim();if(!code||busy)return;
 relines(function(){
  return postCode(code).then(function(){
   var hit=codeList().filter(function(c){return String(c.code).toLowerCase()===code.toLowerCase();})[0];
   if(!hit||!hit.applicable){
    /* neplatný kód nenecháváme viset v košíku — jinak si ho zákazník nese dál a mate ho */
    return postCode('').then(function(){toast('Kód „'+code+'" neplatí pro tento košík');});
   }
   var pct=cartCodePct(),sw=linesToSwitch(pct);
   if(!sw.length){toast('Kód '+code+' použit · −'+Math.round(pct)+' %');return;}
   if(!sw.every(function(l){return targetFullPlanId(l);})){
    /* hranice překročena, ale plán bez slevy zatím neexistuje → kód raději nepustíme dál,
       než abychom tiše nechali slevy sčítat */
    return postCode('').then(function(){
     toast('Kód nad '+CODE_MIN+' % zatím nelze použít s předobjednávkovou cenou');
    });
   }
   /* Spočítej OBĚ varianty a nech rozhodnout člověka. Přepnutí je při plánu 8 % a kódu 9 %+
      vždy levnější, ale u skupiny 12 % nemusí být — proto se čísla počítají, ne předpokládají. */
   var keepTotal=CART.total_price;
   var switched=0;
   (CART.items||[]).forEach(function(l){
    var v=variantOf(l),full=v?+v.price*l.quantity:+l.original_line_price;
    switched+=(sw.indexOf(l)>=0)?Math.round(full*(1-pct/100)):+l.final_line_price;
   });
   CODEPEND={code:code,pct:pct,keys:sw.map(function(l){return l.key;}),keep:keepTotal,swi:switched};
   render();
  });
 });
}
/* potvrzeno → přepni každý dotčený řádek na plán bez slevy; kód se přepočítá sám */
function confirmCodeSwitch(){
 if(!CODEPEND||busy)return;
 var keys=CODEPEND.keys.slice();CODEPEND=null;
 relines(function(){
  return keys.reduce(function(p,k){
   return p.then(function(){
    var l=CART.items.find(function(x){return x.key===k;});if(!l)return;
    var t=targetFullPlanId(l);if(!t)return;
    return inPlace(l,{planId:t});
   });
  },Promise.resolve()).then(function(){toast('Kód použit z plných cen · položky čekají na dodávku');});
 });
}
/* odmítnuto → kód pryč, předobjednávkové ceny zůstávají */
function cancelCodeSwitch(){
 if(!CODEPEND||busy)return;
 CODEPEND=null;
 relines(function(){return postCode('').then(function(){toast('Kód nepoužit, předobjednávkové ceny zůstávají');});});
}
function assignRoom(key,room){
 var l=CART.items.find(function(x){return x.key===key;});if(!l||roomOf(l)===room)return;
 if(busy)return;
 /* isNew must be read BEFORE the optimistic push below, or the check always sees the room we just
    added locally and the Místnosti attribute never gets written. */
 var isNew=!!room&&rooms().indexOf(room)<0;
 /* optimistic: the tile moves now, the network catches up after */
 if(!l.properties)l.properties={};
 if(room)l.properties[ROOM_KEY]=room;else delete l.properties[ROOM_KEY];
 if(isNew){var rs=rooms();rs.push(room);CART.attributes[ROOMS_ATTR]=rs.join('|');}
 render();
 relines(function(){return inPlace(l,{room:room}).then(function(){if(isNew)return addRoomAttr(room);});},key);
}
function setPlan(key,pre){
 var l=CART.items.find(function(x){return x.key===key;});if(!l||lineIsPre(l)===pre)return;
 var pl=planFor(l);
 if(pre&&!pl){toast('Předobjednávka není u tohoto produktu dostupná');return;}
 if(busy)return;
 /* optimistic: the red dot moves to the price you clicked immediately; relines() reconciles from
    the server response, and its catch re-reads the cart if Shopify refuses. */
 l.selling_plan_allocation=pre?{selling_plan:{id:pl.id,name:pl.name}}:null;
 render();
 relines(function(){return inPlace(l,{pre:pre});},key);
}
function setVariant(key,vid){
 var l=CART.items.find(function(x){return x.key===key;});if(!l||l.variant_id===+vid)return;
 relines(function(){return readd(l,{variant_id:+vid});},key);
}
function duplicate(key){
 var l=CART.items.find(function(x){return x.key===key;});if(!l)return;
 relines(function(){
  var it={id:l.variant_id,quantity:l.quantity,properties:{}};
  if(lineIsPre(l))it.selling_plan=l.selling_plan_allocation.selling_plan.id;
  return addItem(it).then(function(){toast('Kopie čeká v Nezařazeno, přiřaďte jí místnost');});
 },key);
}
function addRoomAttr(name){
 var rs=rooms();name=(name||'').trim();if(!name)return Promise.resolve();
 var base=name,i=2;while(rs.indexOf(name)>=0){name=base+' '+i;i++;}
 rs.push(name);var a={};a[ROOMS_ATTR]=rs.join('|');return updateAttrs(a);
}
function renameRoom(oldN,newN){
 newN=(newN||'').trim();if(!newN||newN===oldN)return render();
 relines(function(){
  var rs=rooms(),base=newN,i=2;while(rs.indexOf(newN)>=0){newN=base+' '+i;i++;}
  rs[rs.indexOf(oldN)]=newN;var a={};a[ROOMS_ATTR]=rs.join('|');
  /* alternatives carry the room by NAME, so a rename has to follow them too or they fall out
     of the room and reappear under Nezařazeno */
  var la=alts();
  if(la.some(function(x){return x.room===oldN;}))a[ALT_ATTR]=altStr(la.map(function(x){if(x.room===oldN)x.room=newN;return x;}));
  var moves=CART.items.filter(function(l){return roomOf(l)===oldN;});
  return moves.reduce(function(p,l){return p.then(function(){return readd(l,{room:newN});});},Promise.resolve()).then(function(){return updateAttrs(a);});
 });
}
function deleteRoom(name){
 relines(function(){
  var rs=rooms().filter(function(r){return r!==name;});var a={};a[ROOMS_ATTR]=rs.join('|');
  /* same rule as the lines: cancelling a room never removes anything, it moves it to Nezařazeno */
  var la=alts();
  if(la.some(function(x){return x.room===name;}))a[ALT_ATTR]=altStr(la.map(function(x){if(x.room===name)x.room=null;return x;}));
  var moves=CART.items.filter(function(l){return roomOf(l)===name;});
  return moves.reduce(function(p,l){return p.then(function(){return readd(l,{room:null});});},Promise.resolve()).then(function(){return updateAttrs(a);});
 });
}
function moveRoom(name,dir){
 var rs=rooms(),i=rs.indexOf(name),j=i+dir;if(i<0||j<0||j>=rs.length)return;
 rs.splice(i,1);rs.splice(j,0,name);
 relines(function(){var a={};a[ROOMS_ATTR]=rs.join('|');return updateAttrs(a);});
}
function reorderRoom(name,target){
 if(name===target)return;var rs=rooms();
 rs.splice(rs.indexOf(name),1);rs.splice(rs.indexOf(target),0,name);
 relines(function(){var a={};a[ROOMS_ATTR]=rs.join('|');return updateAttrs(a);});
}
function relocate(key,beforeKey,room){
 var ls=orderedLines(),l=ls.find(function(x){return x.key===key;});if(!l)return;
 ls=ls.filter(function(x){return x.key!==key;});
 var at=beforeKey?ls.findIndex(function(x){return x.key===beforeKey;}):ls.length;if(at<0)at=ls.length;
 ls.splice(at,0,l);
 if(roomOf(l)!==room){assignRoom(key,room);/* order attr refreshed after re-add on next render */}
 else relines(function(){return saveOrder(ls);});
}
/* ---------- quick add: search → Nezařazeno ----------
   Shopify predictive search for the picker, then /products/<handle>.js for the exact price and the
   real variant id — the same cached product JSON the tiles use, so no price is ever guessed. */
var QA={q:'',want:false},qTimer=null,qSeq=0,qRes=[],qSel=-1,qBusy=false;
function qaddHTML(){
 return '<div class="qadd" id="dlk-qadd">'+
  '<div class="qin">'+
   '<svg class="ic" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-4.2-4.2"></path></svg>'+
   '<input id="dlk-q" type="search" autocomplete="off" autocorrect="off" spellcheck="false" placeholder="Přidat produkt · pište název nebo značku" aria-label="Hledat produkt a přidat do košíku">'+
   '<button class="qx" id="dlk-qx" type="button" aria-label="Vymazat" hidden>×</button>'+
  '</div><div class="qres" id="dlk-qres" hidden></div></div>';
}
/* render() rewrites #dlk-app, so the field is re-created on every cart change — put the query and
   the caret back, otherwise adding a second product means clicking into the box again. */
function mountQuickAdd(){
 var i=$('#dlk-q');if(!i)return;
 i.value=QA.q;
 var x=$('#dlk-qx');if(x)x.hidden=!QA.q;
 if(QA.want){try{i.focus();i.setSelectionRange(i.value.length,i.value.length);}catch(e){}}
}
function qClose(){var r=$('#dlk-qres');if(r){r.hidden=true;r.innerHTML='';}qRes=[];qSel=-1;}
function qMsg(t){var r=$('#dlk-qres');if(!r)return;r.innerHTML='<div class="qmsg">'+esc(t)+'</div>';r.hidden=false;}
function qPickVariant(p){
 if(!p||!p.variants||!p.variants.length)return null;
 return p.variants.filter(function(v){return v.available;})[0]||p.variants[0];
}
function qRowHTML(p,i){
 return '<button type="button" class="qi'+(i===qSel?' sel':'')+'" data-qadd="'+esc(p.handle)+'">'+
  '<span class="th">'+(p.image?'<img src="'+esc(imgUrl(p.image,120))+'" alt="" loading="lazy">':'')+'</span>'+
  '<span class="qm"><span class="qb" data-qb="'+esc(p.handle)+'">'+esc(p.vendor||'')+'</span>'+
  '<span class="qn">'+esc(p.title)+'</span></span>'+
  '<span class="qp" data-qp="'+esc(p.handle)+'"></span></button>';
}
function qHydrate(h){
 productFor({handle:h}).then(function(p){
  if(!p||!root)return;
  var sel='"'+String(h).replace(/"/g,'\\"')+'"';
  var el=root.querySelector('[data-qp='+sel+']'),lb=root.querySelector('[data-qb='+sel+']');
  var v=qPickVariant(p);
  if(el&&v){el.textContent=fmt(v.price);el.classList.toggle('na',!v.available);}
  if(lb&&p.variants&&p.variants.length>1){var n=p.variants.length;lb.textContent=(p.vendor||'')+' · '+n+(n<5?' varianty':' variant');}
 });
}
function qRender(){
 var r=$('#dlk-qres');if(!r)return;
 if(!qRes.length){qMsg('Nic jsme nenašli');return;}
 r.innerHTML=qRes.map(qRowHTML).join('');r.hidden=false;
 qRes.forEach(function(p){qHydrate(p.handle);});
}
function qMark(){
 var r=$('#dlk-qres');if(!r)return;
 var b=r.querySelectorAll('.qi');
 for(var i=0;i<b.length;i++)b[i].classList.toggle('sel',i===qSel);
 if(b[qSel]&&b[qSel].scrollIntoView)b[qSel].scrollIntoView({block:'nearest'});
}
function qSearch(term){
 var n=++qSeq;
 var u=(conf.root||'/')+'search/suggest.json?q='+encodeURIComponent(term)+
  '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last'+
  '&resources[options][fields]=title,vendor,product_type,variants.title,variants.sku,tag';
 fetch(u,{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(j){
  if(n!==qSeq)return;
  qRes=(j&&j.resources&&j.resources.results&&j.resources.results.products)||[];
  qSel=qRes.length?0:-1;qRender();
 }).catch(function(){if(n===qSeq)qMsg('Hledání se nepodařilo');});
}
function qReset(focus){
 QA.q='';qSeq++;qClose();
 var i=$('#dlk-q');if(i){i.value='';if(focus){QA.want=true;i.focus();}}
 var x=$('#dlk-qx');if(x)x.hidden=true;
}
function qAdd(handle){
 if(qBusy||busy)return;
 qBusy=true;
 productFor({handle:handle}).then(function(p){
  qBusy=false;
  var v=qPickVariant(p);
  if(!v){toast('Produkt se nepodařilo načíst');return;}
  seedPlans(p);
  qReset(true);
  /* no Místnost property — the line lands in Nezařazeno, which is the point */
  relines(function(){
   return addItem({id:v.id,quantity:1}).then(function(){toast(p.title+' → Nezařazeno');});
  });
 },function(){qBusy=false;});
}
document.addEventListener('input',function(e){
 if(e.target.id!=='dlk-q')return;
 QA.q=e.target.value;
 var x=$('#dlk-qx');if(x)x.hidden=!QA.q;
 clearTimeout(qTimer);
 var t=QA.q.trim();
 if(t.length<2){qSeq++;qClose();return;}
 qTimer=setTimeout(function(){qSearch(t);},220);
});
document.addEventListener('focusin',function(e){
 if(e.target.id==='dlk-q'){QA.want=true;if(qRes.length&&QA.q.trim().length>=2)qRender();}
 else if(!(e.target.closest&&e.target.closest('#dlk-qadd')))QA.want=false;
});
document.addEventListener('keydown',function(e){
 if(e.target.id!=='dlk-q')return;
 if(e.key==='ArrowDown'||e.key==='ArrowUp'){
  if(!qRes.length)return;
  e.preventDefault();qSel=(qSel+(e.key==='ArrowDown'?1:-1)+qRes.length)%qRes.length;qMark();
 }else if(e.key==='Enter'){
  e.preventDefault();var p=qRes[qSel<0?0:qSel];if(p)qAdd(p.handle);
 }else if(e.key==='Escape'){e.stopPropagation();qClose();}
});
document.addEventListener('click',function(e){
 if(!e.target.closest)return;
 var a=e.target.closest('[data-qadd]');
 if(a){e.preventDefault();qAdd(a.dataset.qadd);return;}
 if(e.target.closest('#dlk-qx')){qReset(true);return;}
 if(!e.target.closest('#dlk-qadd'))qClose();
});
/* ---------- render ---------- */
var UIRoomsOn=null;
function roomsOn(){if(UIRoomsOn===null)UIRoomsOn=!!(rooms().length||CART.items.some(roomOf)||alts().some(function(a){return a.room;}));return UIRoomsOn;}
function thm(l){return '<span class="thm">'+(l.image?'<img src="'+esc(imgUrl(l.image,600))+'" alt="" loading="lazy">':'')+'</span>';}
function lineHTML(l){
 var p=PRODUCTS[l.handle],v=p&&p.variants?p.variants.find(function(x){return x.id===l.variant_id;}):null;
 var inStock=v?v.available:true;
 var flags='';
 if(lineIsPre(l))flags+='<span class="flag pre ponly"><span class="dot"></span>'+esc(l.selling_plan_allocation.selling_plan.name)+'</span>';
 if(SHOWROOM&&p&&p.tags&&p.tags.indexOf('vystaveno')>=0)flags+='<span class="flag show"><span class="dot"></span>'+esc(SHOWROOM)+'</span>';
 var pl=planFor(l);
 /* the two prices ARE the availability choice — no separate Dostupnost row.
    Exact plan price comes from the variant's selling_plan_allocations (no percentage maths). */
 var alloc=null;
 if(v&&v.selling_plan_allocations&&pl){
  alloc=v.selling_plan_allocations.filter(function(a){return +a.selling_plan_id===+pl.id;})[0]||null;
 }
 var q=l.quantity;
 var stockUnit=v?v.price:(lineIsPre(l)?l.original_price:l.final_price);
 var planUnit=alloc?alloc.price:(lineIsPre(l)?l.final_price:0);
 var pre=lineIsPre(l);
 var tipIn='Skladem ihned · odesíláme ihned ze skladu';
 var tipPre='Počkám na příští objednávku'+(pl?' · '+pl.name:'')+' · nižší cena výměnou za delší dodání (2–5 týdnů)';
 var prices='<span class="pr">'+
  '<span class="prow"><button class="po'+(pre?'':' on')+'"'+(inStock?' data-plan-set="'+esc(l.key)+'|in"':' disabled title="Není skladem"')+'>'+
  '<i class="dot"></i><b>'+fmt(stockUnit*q)+'</b><span class="plb">Skladem</span></button>'+
  '<span class="inf" tabindex="0" role="button" aria-label="'+esc(tipIn)+'" data-tip="'+esc(tipIn)+'">i</span></span>'+
  ((alloc||pre)?'<span class="prow"><button class="po pre'+(pre?' on':'')+'" data-plan-set="'+esc(l.key)+'|pre">'+
   '<i class="dot"></i><b>'+fmt(planUnit*q)+'</b><span class="plb">Počkám</span></button>'+
   '<span class="inf" tabindex="0" role="button" aria-label="'+esc(tipPre)+'" data-tip="'+esc(tipPre)+'">i</span></span>':'')+
  '</span>';
 var vhtml='';
 if(p&&p.variants&&p.variants.length>1){
  vhtml='<span class="vrow"><span class="vlab">Varianta</span><span class="seg">'+
   '<button class="sg vbtn" data-vopen="'+esc(l.key)+'" title="Vybrat variantu">'+
   '<span class="vt">'+esc(l.variant_title||'Vybrat variantu')+'</span><span class="ar">▾</span></button></span></span>';
 }
 var rsel='';
 if(roomsOn()){
  var cur=roomOf(l),list=rooms();
  rsel='<span class="vrow"><span class="vlab">Místnost</span><span class="dd">'+
   '<button class="ddt" data-ddt="'+esc(l.key)+'"><span class="ddv">'+esc(cur||'Nezařazeno')+'</span><span class="ar">▾</span></button>'+
   '<span class="ddm" hidden>'+
   '<button class="ddi'+(!cur?' on':'')+'" data-room-set="'+esc(l.key)+'|">Nezařazeno</button>'+
   list.map(function(r){return '<button class="ddi'+(r===cur?' on':'')+'" data-room-set="'+esc(l.key)+'|'+esc(r)+'">'+esc(r)+'</button>';}).join('')+
   '</span></span></span>';
 }
 return '<div class="cline" draggable="true" data-key="'+esc(l.key)+'">'+
  '<button class="grab" aria-label="Přetáhnout" tabindex="-1"><svg class="ic" viewBox="0 0 14 18"><circle cx="4" cy="3" r="1.2"></circle><circle cx="10" cy="3" r="1.2"></circle><circle cx="4" cy="9" r="1.2"></circle><circle cx="10" cy="9" r="1.2"></circle><circle cx="4" cy="15" r="1.2"></circle><circle cx="10" cy="15" r="1.2"></circle></svg></button>'+
  thm(l)+'<div class="cbody">'+
  '<div class="mid">'+brandMark(l.vendor)+'<span class="nm"><a href="'+esc(l.url)+'">'+esc(l.product_title)+'</a></span>'+
  (flags?'<span class="flags">'+flags+'</span>':'')+'</div>'+
  '<div class="opts">'+vhtml+rsel+'</div>'+
  '<div class="end">'+prices+
  '<div class="erow"><span class="qty"><button data-dec="'+esc(l.key)+'" aria-label="Méně">−</button><span>'+l.quantity+'</span><button data-inc="'+esc(l.key)+'" aria-label="Více">+</button></span></div>'+
  '<div class="lacts">'+(roomsOn()?'<button class="rm" data-dup="'+esc(l.key)+'" title="Stejná položka do další místnosti">Duplikovat</button>':'')+'<button class="rm" data-rm="'+esc(l.key)+'">Odebrat</button></div></div>'+
  '</div></div>';
}
/* A 0-qty tile. Deliberately thinner than lineHTML: no variant picker, no Skladem/Počkám toggle,
   no duplicate, not draggable. An alternative is a candidate, not a configuration — you promote it
   with + and then it is an ordinary line with all the controls back. What it does keep is the room
   dropdown, because "which spot is this an option for" is the whole point of parking it. */
function ghostHTML(a){
 var p=PRODUCTS[a.handle];
 var v=p&&p.variants?p.variants.find(function(x){return x.id===a.vid;}):null;
 var img=(v&&v.featured_image&&v.featured_image.src)||(p&&p.featured_image)||'';
 var title=p?p.title:'Načítám…';
 var vt=v&&v.title&&v.title!=='Default Title'?v.title:'';
 var unit=v?v.price:0,plab='';
 if(a.plan&&v&&v.selling_plan_allocations){
  var al=v.selling_plan_allocations.filter(function(x){return +x.selling_plan_id===+a.plan;})[0];
  if(al){unit=al.price;plab='Počkám';}
 }
 var gone=!!(p&&v&&!v.available);
 var rsel='';
 if(roomsOn()){
  var cur=a.room,list=rooms();
  rsel='<span class="vrow"><span class="vlab">Místnost</span><span class="dd">'+
   '<button class="ddt" data-ddt="g'+a.i+'"><span class="ddv">'+esc(cur||'Nezařazeno')+'</span><span class="ar">▾</span></button>'+
   '<span class="ddm" hidden>'+
   '<button class="ddi'+(!cur?' on':'')+'" data-galt-room="'+a.i+'|">Nezařazeno</button>'+
   list.map(function(r){return '<button class="ddi'+(r===cur?' on':'')+'" data-galt-room="'+a.i+'|'+esc(r)+'">'+esc(r)+'</button>';}).join('')+
   '</span></span></span>';
 }
 return '<div class="cline gh" data-galt="'+a.i+'">'+
  '<span class="grab gsp" aria-hidden="true"></span>'+
  '<span class="thm">'+(img?'<img src="'+esc(imgUrl(img,600))+'" alt="" loading="lazy">':'')+'</span>'+
  '<div class="cbody">'+
  '<div class="mid">'+brandMark(p?p.vendor:'')+
  '<span class="nm">'+(p?'<a href="'+esc((conf.root||'/')+'products/'+a.handle)+'">'+esc(title)+'</a>':esc(title))+'</span>'+
  '<span class="flags"><span class="flag zero"><span class="dot"></span>Alternativa · nepočítá se</span>'+
  (plab?'<span class="flag pre ponly"><span class="dot"></span>'+esc(plab)+'</span>':'')+
  (gone?'<span class="flag oos"><span class="dot"></span>Není skladem</span>':'')+'</span></div>'+
  '<div class="opts">'+(vt?'<span class="vrow"><span class="vlab">Varianta</span><span class="vfix">'+esc(vt)+'</span></span>':'')+rsel+'</div>'+
  '<div class="end">'+
  /* the leading <i class="dot"> is not decoration: every real line's .po starts with one and
     .po has gap:9px, so omitting it slides the whole price block 17px left of the picks it is
     meant to be compared against. Same element, invisible, same alignment. */
  '<span class="pr"><span class="prow"><span class="po gp"><i class="dot"></i><b>'+fmt(unit)+'</b><span class="plb">za kus</span></span></span></span>'+
  '<div class="erow"><span class="qty"><button disabled aria-label="Méně">−</button><span>0</span>'+
  '<button data-galt-up="'+a.i+'" aria-label="Přidat do počtu" title="Přidat do počtu">+</button></span></div>'+
  '<div class="lacts"><button class="rm" data-galt-rm="'+a.i+'">Odebrat</button></div></div>'+
  /* BOTH closers: one for .cbody, one for .cline. Emitting only one left .cline open, so the
     next alternative was parsed as a CHILD of this card — tiles nested inside tiles, each body
     squeezed to less than half width. It renders "fine" with a single alternative, which is
     exactly why it slipped through; see the structural test in the harness. */
  '</div></div>';
}
function galtHTML(gs){
 if(!gs.length)return '';
 return '<div class="galt"><span class="gl">Alternativy — nepočítají se do součtu ani do objednávky</span>'+
  '<div class="rbody gb">'+gs.map(ghostHTML).join('')+'</div></div>';
}
function roomSectionHTML(name,ls){
 var sum=ls.reduce(function(a,l){return a+l.final_line_price;},0);
 var gs=altsIn(name);
 var head='<div class="rhead"'+(name!==null?' draggable="true" data-rdrag="'+esc(name)+'"':'')+'>'+
  (name===null?'<span class="rnm" style="color:var(--mute)">Nezařazeno</span>'
   :'<span class="rnm" contenteditable="true" spellcheck="false" data-room="'+esc(name)+'">'+esc(name)+'</span><button class="pen" data-pen="'+esc(name)+'" aria-label="Přejmenovat"><svg class="ic" viewBox="0 0 24 24"><path d="M17 3l4 4L8 20l-5 1 1-5z"></path></svg></button>')+
  '<span class="sp"></span><span class="rsum">'+fmt(sum)+'</span>'+
  (name!==null?'<button class="rmv" data-rup="'+esc(name)+'" aria-label="Posunout výš">↑</button><button class="rmv" data-rdn="'+esc(name)+'" aria-label="Posunout níž">↓</button><button class="rdel" data-rdel="'+esc(name)+'" aria-label="Zrušit místnost"><svg class="ic" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"></path></svg></button>':'')+'</div>';
 var body='<div class="rbody">'+(ls.length?ls.map(lineHTML).join('')
  :'<div class="rempty" style="grid-column:1/-1">'+(gs.length
    ?'Zatím jen alternativy — u jedné z nich klepněte na + a stane se hlavním výběrem'
    :'Přetáhněte sem svítidla, nebo je přiřaďte u položky')+'</div>')+'</div>';
 return '<section class="rsec" data-drop="'+(name===null?'':esc(name))+'">'+head+body+galtHTML(gs)+'</section>';
}
function render(){
 var app=$('#dlk-app');
 /* FIX 2026-08-11: the mini-cart drawer runs site-wide, but #dlk-app exists only on the
    cart page. Off-cart this lookup returns null and every app.innerHTML below throws a
    TypeError, so after a drawer removal the drawer never re-rendered and the removed row
    stayed on screen. Refresh the drawer and bail out instead of touching a null node. */
 if(!app){renderDrawer();return;}
 /* a board holding nothing but alternatives is not an empty cart — it is a shortlist waiting for
    someone to pick, and hiding it would look like the client's options were thrown away */
 if(!CART.item_count&&!alts().length){
  app.innerHTML=qaddHTML()+'<div class="empty"><h1>Košík je prázdný</h1><p>Zatím v něm nic nesvítí.</p><a class="go" href="'+esc(conf.catalogUrl||'/collections/all')+'">Kompletní katalog →</a></div>';
  mountQuickAdd();renderDrawer();return;
 }
 var ls=orderedLines(),rs=rooms();
 var main;
 if(!roomsOn())main='<div class="flat">'+ls.map(lineHTML).join('')+'</div>'+galtHTML(alts());
 else{
  main='';
  rs.forEach(function(r){main+=roomSectionHTML(r,ls.filter(function(l){return roomOf(l)===r;}));});
  var un=ls.filter(function(l){return !roomOf(l)||rs.indexOf(roomOf(l))<0;});
  /* Nezařazeno must also appear when it holds nothing but alternatives — otherwise an alternative
     moved out of a room (or one arriving from a share link with no room) is silently invisible
     while still counting towards the checkout gate: buttons locked, nothing on screen to unlock them. */
  if(un.length||altsIn(null).length||!rs.length)main+=roomSectionHTML(null,un);
  main+='<div class="addroom"><span class="m">Přidat místnost</span><div class="chips">'+
   PRESETS.map(function(p){return '<button class="chip" data-chip="'+esc(p)+'">'+esc(p)+'</button>';}).join('')+
   '</div><div class="custom"><input id="dlk-roomname" type="text" placeholder="Vlastní název, třeba Půda" maxlength="40"><button id="dlk-roomadd">Přidat</button></div></div>';
 }
 app.innerHTML='<div class="phead"><h1>Košík</h1><span class="cnt">'+plural(CART.item_count)+'</span><span class="sp"></span>'+
  '<button class="rswitch'+(roomsOn()?' on':'')+'" id="dlk-rswitch" role="switch"><span class="lb">Rozdělit podle místností</span><span class="tk"></span></button></div>'+
  qaddHTML()+
  '<div class="board"><div class="cmain">'+main+'</div><aside class="csum" id="dlk-sum"></aside></div>';
 renderSummary();renderDrawer();mountQuickAdd();
 $('#dlk-rswitch').addEventListener('click',function(){UIRoomsOn=!roomsOn();render();});
 /* alternatives carry only a variant id and a handle, so their photo, title, vendor and price all
    come from the same product JSON the lines use — fetch theirs in the same pass */
 var need=CART.items.filter(function(l){return !PRODUCTS[l.handle];})
  .concat(alts().filter(function(a){return !PRODUCTS[a.handle];}).map(function(a){return {handle:a.handle};}));
 if(need.length)Promise.all(need.map(productFor)).then(function(){if(!busy)render();});
}
function tier(){var t=CART.total_price;return t>ORD_MAND?'mand':(t>=ORD_MIN?'opt':'classic');}
function renderSummary(){
 var st=CART.total_price,free=st>=FREE,pct=Math.min(100,Math.round(st/FREE*100));
 var saved=CART.items.reduce(function(a,l){return a+(unitCompare(l)?(unitCompare(l)-l.final_price)*l.quantity:0);},0);
 var pre=CART.items.some(lineIsPre);
 /* Nothing leaves the cart while a 0-qty tile is unresolved. The buttons are disabled AND the two
    handlers re-check alts() — a disabled button cannot be clicked, but the drawer, the ?ord=1
    deep link and a keyboard path all reach the same flows by other doors. */
 var na=alts().length,dis=na?' disabled aria-disabled="true"':'';
 var ORD='<button class="ordbtn" data-ord'+dis+'><b>Poslat objednávku</b><span class="sub">Na fakturu, bez okamžité platby</span></button>';
 var acts;
 if(tier()==='classic')acts='<button class="co" data-co'+dis+'>Pokračovat k pokladně</button>';
 else if(tier()==='opt')acts=ORD+'<button class="co" data-co'+dis+'>Pokračovat k pokladně</button>';
 else acts=ORD.replace('"ordbtn"','"ordbtn prime"')+'<p class="ordnote">Nad '+fmt(ORD_MAND)+' vyřizujeme objednávky na fakturu</p>';
 if(na)acts='<p class="zwarn"><b>'+plural(na)+' s nulovým množstvím.</b> Než odešlete poptávku nebo půjdete k pokladně, přidejte je do počtu tlačítkem +, nebo je odeberte.</p>'+acts;
 /* the undo takes the remove button's own place, so the row never jumps under the cursor */
 var zrow=UNDO?'<div class="zrow"><button class="zundo" data-zundo><svg class="ic" viewBox="0 0 24 24"><path d="M9 14 4 9l5-5"></path><path d="M4 9h11a5 5 0 0 1 0 10h-4"></path></svg>Vrátit zpět ('+UNDO.n+')</button></div>'
  :(na?'<div class="zrow"><button class="zclear" data-zclear>Odebrat nulové položky ('+na+')</button></div>':'');
 if(D.orderPopup!=='true')acts=acts; /* dl-order.js may replace buttons — see BINDINGS */
 $('#dlk-sum').innerHTML=
  '<div class="blk ship"><div class="lbl">'+(free?'<span>Doprava</span><b>Zdarma ✓</b>':'<span>Do dopravy zdarma zbývá</span><b style="color:var(--ink)">'+fmt(FREE-st)+'</b>')+'</div><div class="track'+(free?' full':'')+'"><i style="width:'+pct+'%"></i></div></div>'+
  '<div class="blk">'+
  '<div class="rw"><span class="k">Mezisoučet</span><span class="v">'+fmt(st)+'</span></div>'+
  (saved?'<div class="rw"><span class="k">Ušetříte předobjednávkou</span><span class="v" style="color:var(--red-ink)">−'+fmt(saved)+'</span></div>':'')+
  '<div class="rw"><span class="k">Doprava</span><span class="v">'+(free?'Zdarma':'od '+fmt(SHIP_FROM))+'</span></div>'+
  '<div class="rw tot"><span class="k">Celkem</span><span class="v">'+fmt(st)+'</span></div><div class="vat">vč. DPH</div>'+
  (pre?'<div class="note"><span class="dot"></span><span>Košík obsahuje předobjednávky, tyto položky odešleme za 2–5 týdnů.</span></div>':'')+'</div>'+
  '<div class="blk mont" id="dlk-mont"></div>'+
  codeBlockHTML()+
  '<div class="blk actions"><div class="coacts">'+acts+'</div>'+zrow+
  '<div class="sharerow"><button data-share><svg class="ic" viewBox="0 0 24 24"><circle cx="6" cy="12" r="2.5"></circle><circle cx="18" cy="6" r="2.5"></circle><circle cx="18" cy="18" r="2.5"></circle><path d="m8.2 10.8 7.6-3.6M8.2 13.2l7.6 3.6"></path></svg>Sdílet košík</button>'+
  '<button data-print><svg class="ic" viewBox="0 0 24 24"><path d="M7 8V3h10v5M7 17H4V9h16v8h-3"></path><path d="M7 14h10v7H7z"></path></svg>Plán do PDF</button></div>'+
  '<label class="dlk-pricetog"><input type="checkbox" data-prices checked> Tisknout ceny</label>'+
  '<p class="hint">Odkaz obnoví celý košík včetně místností. Pošlete ho klientovi, upraví si ho sám.</p></div>'+
  /* Trust blok odstraněn 2026-09-04. Všechny tři sliby byly nepodmíněné a tím nepravdivé:
     „Vrácení do 30 dnů" u zboží objednaného na zakázku znamená, že zboží zůstane nám a peníze jdou
     zpět; „Osobní odběr do 24 h" platí jen pro skladem — na zakázku to bývají měsíce; a doprava
     zdarma neplatí pro nadrozměrné kusy. Podmíněné verze se dají postavit (košík ví o každém
     řádku, jestli je Skladem nebo Počkám), ale slibovat se nemá nic, co neplatí vždy. */
  '';
 var ptg=$('[data-prices]');if(ptg&&window.DLK_printPricesOn)ptg.checked=!!window.DLK_printPricesOn();
 renderMont();
}
/* Pole pro slevový kód. Tři stavy: prázdné, čekající na rozhodnutí (CODEPEND), použité. */
function codeBlockHTML(){
 if(CODEPEND){
  var cheaper=CODEPEND.swi<=CODEPEND.keep;
  return '<div class="blk code pend"><div class="cdq">'+
   '<b>Kód '+esc(CODEPEND.code)+' dá −'+Math.round(CODEPEND.pct)+' % z plných cen.</b>'+
   '<span>'+plural(CODEPEND.keys.length)+' máte za předobjednávkovou cenu. Slevy se nesčítají, '+
   'takže se u nich zruší předobjednávková sleva a kód se spočítá z plné ceny. '+
   'Položky dál čekají na dodávku a nesáhnou na skladem dostupné kusy.</span></div>'+
   '<div class="cdc"><span class="cdr"><span class="k">bez kódu</span><span class="v">'+fmt(CODEPEND.keep)+'</span></span>'+
   '<span class="cdr'+(cheaper?' win':'')+'"><span class="k">s kódem</span><span class="v">'+fmt(CODEPEND.swi)+'</span></span></div>'+
   (cheaper?'':'<p class="cdw">S kódem by to vyšlo dráž — předobjednávková cena je pro vás výhodnější.</p>')+
   '<div class="cda"><button class="cdok'+(cheaper?'':' alt')+'" data-cdok>Použít kód</button>'+
   '<button class="cdno'+(cheaper?'':' prime')+'" data-cdno>Nechat předobjednávkové ceny</button></div></div>';
 }
 var live=liveCode(),dead=deadCode();
 if(live){
  return '<div class="blk code on"><div class="cdon"><span class="tag">Kód</span><b>'+esc(live.code)+'</b>'+
   (CART.total_discount?'<span class="amt">−'+fmt(CART.total_discount)+'</span>':'')+
   '<button class="cdx" data-cdx aria-label="Odebrat kód">×</button></div></div>';
 }
 /* Bez viditelného labelu (Hynek, 2026-09-04) — placeholder „PROMOKÓD" nese význam sám.
    aria-label zůstává, jinak by pole pro odečítač obrazovky bylo bezejmenné. */
 return '<div class="blk code">'+
  '<div class="cdf"><input id="dlk-code" type="text" autocomplete="off" spellcheck="false" aria-label="Slevový kód" placeholder="PROMOKÓD"'+
  (dead?' value="'+esc(dead.code)+'"':'')+'><button data-cdgo>Použít</button></div>'+
  (dead?'<p class="cdw">Kód „'+esc(dead.code)+'" pro tento košík neplatí.</p>':'')+'</div>';
}
/* montáž (cart attributes) — master value matches the LIVE convention exactly:
   'ANO, poslat cenovou nabídku' when on, key blank/absent when off (contract: empty = absent). */
var MNT_ON='ANO, poslat cenovou nabídku';
/* contract v1.3.0 §2.3 — MSI still reads the superseded joined key. Write it too until the bump. */
function legacyOdstr(dem,lik){
 var o=[];
 if(dem==='Ano')o.push('Demontáž stávajících svítidel');
 if(lik==='Ano')o.push('Odvoz a likvidace stávajících svítidel');
 return o.join(', ');
}
/* v1.4.0 §3 — výška stropu se ukládá VČETNĚ jednotky. MSI si to vyžádalo: montážní tým
   podle ní volí žebřík a "2,5" bez jednotky si nemá kdo ověřovat telefonem.
   Převádíme jen tam, kde je to jednoznačné: >= 100 jsou zjevně centimetry (220, 450).
   Čísla 20–99 jsou nesmysl v obou jednotkách, takže se jen doplní " m" a nechá se to
   montážníkovi na oči — raději viditelně divná hodnota než tiše vymyšlená.
   Hodnota, která už jednotku nebo jakýkoli text má, se nechává být. */
function normCeil(v){
 v=String(v==null?'':v).trim();
 if(!v)return '';
 var m=v.replace(',','.').match(/^([0-9]+(?:\.[0-9]+)?)$/);
 if(!m)return v;
 var n=parseFloat(m[1]);
 if(!(n>0))return v;
 if(n>=100)n=n/100;
 return (Math.round(n*100)/100).toString().replace('.',',')+' m';
}
/* v1.4.0 §3 — adresa instalace jde do JEDNOHO klíče jako "ulice, PSČ město" (MSI odmítlo tři
   samostatné klíče — páruje fuzzy přes celý řetězec). Formulář má tři pole, tyhle dvě funkce
   drží obousměrný převod. Starší jednořádkové hodnoty bez PSČ se při čtení celé vloží do
   ulice, ať se nic neztratí — zákazník pak jen doplní zbytek. */
function addrJoin(u,p,m){
 u=String(u||'').trim();p=String(p||'').trim();m=String(m||'').trim();
 var tail=(p+' '+m).trim();
 if(u&&tail)return u+', '+tail;
 return u||tail;
}
function addrSplit(v){
 var s=String(v||'').trim(),out={u:'',p:'',m:''};
 if(!s)return out;
 var i=s.lastIndexOf(',');
 if(i<0){out.u=s;return out;}
 var t=s.slice(i+1).trim().match(/^([0-9]{3} ?[0-9]{2})[ ]+(.+)$/);
 if(t){out.u=s.slice(0,i).trim();out.p=t[1];out.m=t[2];return out;}
 out.u=s;return out;
}
function addrDone(u,p,m){return !!(String(u||'').trim()&&String(p||'').trim()&&String(m||'').trim());}
/* v1.4.0 §2.8 — odkaz na košík se píše do objednávky JEN u požadavků na montáž. U ostatních
   objednávek nemá 766znaková URL v "Dodatečných údajích" co dělat. Zápis jde jen při skutečné
   změně hodnoty, jinak by každý render posílal ten řetězec znovu. */
var KOSIK_ODKAZ='Košík - odkaz',linkT;
function syncCartLink(){
 if(!CART||!CART.attributes)return;
 var want=mntOn()?buildShareLink():'';
 if(String(CART.attributes[KOSIK_ODKAZ]||'')===want)return;
 clearTimeout(linkT);
 linkT=setTimeout(function(){
  var a={};a[KOSIK_ODKAZ]=want;
  updateAttrs(a)['catch'](function(){});
 },800);
}
var MNT_MAP={minst:'Montáž - adresa instalace',mstrop:'Montáž - výška stropu',mmat:'Montáž - materiál stropu',msmart:'Montáž - smart home',msmartw:'Montáž - smart home systém',mtermin:'Montáž - termín',mdemont:'Montáž - demontáž stávajících',mlikvid:'Montáž - likvidace stávajících',mpozn:'Montáž - poznámka'};
function mntOn(){return String(CART.attributes['Montáž']||'').indexOf('ANO')===0;}
function renderMont(){
 var a=CART.attributes,on=mntOn(),ad=addrSplit(a[MNT_MAP.minst]);
 $('#dlk-mont').innerHTML='<label class="mntg"><input type="checkbox" id="dlk-mntchk"'+(on?' checked':'')+'> Mám zájem o montáž</label>'+
  '<p class="hint" style="margin-top:6px">Instalace našimi techniky. Požadavek putuje s objednávkou, ať platíte kartou nebo na fakturu.</p>'+
  '<div class="fgrid" id="dlk-mntf"'+(on?'':' hidden')+'>'+
  '<label class="full">Ulice a číslo *<input name="minst_u" type="text" placeholder="Sázavská 2031/32" value="'+esc(ad.u)+'"></label>'+
  '<label>PSČ *<input name="minst_p" type="text" inputmode="numeric" maxlength="6" placeholder="120 00" value="'+esc(ad.p)+'"></label>'+
  '<label>Město *<input name="minst_m" type="text" placeholder="Praha" value="'+esc(ad.m)+'"></label>'+
  '<label>Výška stropu<input name="mstrop" type="text" placeholder="např. 2,7 m" value="'+esc(a[MNT_MAP.mstrop])+'"></label>'+
  '<label>Materiál stropu<input name="mmat" type="text" placeholder="nevím" list="dlk-mmats" value="'+esc(a[MNT_MAP.mmat])+'"></label>'+
  '<label>Smart home<span class="seg segf"><button type="button" class="sg'+(a[MNT_MAP.msmart]==='Ano'?'':' on')+'" data-seg="msmart|Ne">Ne</button><button type="button" class="sg'+(a[MNT_MAP.msmart]==='Ano'?' on':'')+'" data-seg="msmart|Ano">Ano</button></span><input type="hidden" name="msmart" value="'+esc(a[MNT_MAP.msmart]||'Ne')+'"></label>'+
  '<label class="smw"'+(a[MNT_MAP.msmart]==='Ano'?'':' hidden')+'>Který systém<input name="msmartw" type="text" placeholder="např. Loxone, KNX" value="'+esc(a[MNT_MAP.msmartw])+'"></label>'+
  '<label>Termín<input name="mtermin" type="date" value="'+esc(a[MNT_MAP.mtermin])+'"></label>'+
  '<div class="full checks">'+
  '<label class="chk"><input type="checkbox" name="mdemont"'+(a[MNT_MAP.mdemont]==='Ano'?' checked':'')+'> Demontáž stávajících svítidel</label>'+
  '<label class="chk"><input type="checkbox" name="mlikvid"'+(a[MNT_MAP.mlikvid]==='Ano'?' checked':'')+'> Likvidace stávajících svítidel</label></div>'+
  '<label class="full">Poznámka<textarea name="mpozn" rows="2" placeholder="Krytky vypínačů ABB tango, hluboké / mělké kolébky">'+esc(a[MNT_MAP.mpozn])+'</textarea></label>'+
  '<p class="hint full" id="dlk-mntreq"'+(addrDone(ad.u,ad.p,ad.m)?' hidden':'')+'>Doplňte prosím ulici, PSČ i město — montážní tým podle adresy plánuje výjezd.</p></div>'+
  '<datalist id="dlk-mmats"><option value="sádrokarton"></option><option value="cihla"></option><option value="beton"></option><option value="rákos"></option></datalist>';
 syncCartLink();
}
function fval(root,n){var el=root&&root.querySelector('[name="'+n+'"]');return el?el.value:'';}
var mntT;
function mntSave(){
 clearTimeout(mntT);
 mntT=setTimeout(function(){
  var f=$('#dlk-mntf'),a={};a['Montáž']=$('#dlk-mntchk').checked?MNT_ON:'';
  Object.keys(MNT_MAP).forEach(function(k){
   var el=f.querySelector('[name="'+k+'"]');if(!el)return;
   a[MNT_MAP[k]]=el.type==='checkbox'?(el.checked?'Ano':''):el.value;
  });
  /* v1.4.0: adresa se sklada ze tri poli do jednoho klice, vyska stropu dostane jednotku.
     `minst` uz v MNT_MAP smycce nema co chytit — pole [name=minst] neexistuje. */
  var vu=fval(f,'minst_u'),vp=fval(f,'minst_p'),vm=fval(f,'minst_m');
  a[MNT_MAP.minst]=addrJoin(vu,vp,vm);
  a[MNT_MAP.mstrop]=normCeil(a[MNT_MAP.mstrop]);
  a['Montáž - odstranění stávajících']=legacyOdstr(a[MNT_MAP.mdemont],a[MNT_MAP.mlikvid]);
  var rq=$('#dlk-mntreq');if(rq)rq.hidden=addrDone(vu,vp,vm);
  updateAttrs(a).then(getCart).then(syncCartLink);
 },600);
}
/* ---------- events ---------- */
document.addEventListener('click',function(e){
 var t=e.target.closest('[data-inc],[data-dec],[data-rm],[data-dup],[data-chip],[data-rdel],[data-pen],[data-rup],[data-rdn],[data-plan-set],[data-var-set],[data-room-set],[data-rexp],[data-share],[data-print],[data-prices],[data-co],[data-seg],[data-galt-up],[data-galt-rm],[data-galt-room],[data-zclear],[data-zundo],[data-cdgo],[data-cdx],[data-cdok],[data-cdno],#dlk-roomadd,#dlk-mntchk');
 if(!t)return;
 var L=function(k){return CART.items.find(function(x){return x.key===k;});};
 if(t.dataset.inc!==undefined)bumpQty(t.dataset.inc,1);
 else if(t.dataset.dec!==undefined)bumpQty(t.dataset.dec,-1,!!(t.closest&&t.closest('#dlk-dwr')));
 else if(t.dataset.rm!==undefined)setQty(t.dataset.rm,0);
 else if(t.dataset.dup!==undefined)duplicate(t.dataset.dup);
 else if(t.dataset.chip)relines(function(){return addRoomAttr(t.dataset.chip);});
 else if(t.dataset.rdel)confirmDelete(t.dataset.rdel);
 else if(t.dataset.rup)moveRoom(t.dataset.rup,-1);
 else if(t.dataset.rdn)moveRoom(t.dataset.rdn,1);
 else if(t.dataset.pen!==undefined){var el=root.querySelector('.rnm[data-room="'+t.dataset.pen.replace(/"/g,'\\"')+'"]');if(el){el.focus();document.getSelection().selectAllChildren(el);}}
 else if(t.dataset.planSet){var ps=t.dataset.planSet.split('|');setPlan(ps[0],ps[1]==='pre');}
 else if(t.dataset.varSet){var vv=t.dataset.varSet.split('|');setVariant(vv[0],vv[1]);}
 else if(t.dataset.roomSet!==undefined){var q=t.dataset.roomSet,ix=q.lastIndexOf('|');assignRoom(q.slice(0,ix),q.slice(ix+1)||null);}
 else if(t.dataset.rexp!==undefined){rexp[t.dataset.rexp]=1;render();}
 else if(t.dataset.share!==undefined)openShare();
 else if(t.dataset.print!==undefined){if(window.DLK_printSheets)window.DLK_printSheets();window.print();}
 else if(t.dataset.prices!==undefined){window.DLK_printPrices&&window.DLK_printPrices(t.checked);}
 else if(t.dataset.galtUp!==undefined)promote(+t.dataset.galtUp);
 else if(t.dataset.galtRm!==undefined)dropAlt(+t.dataset.galtRm);
 else if(t.dataset.galtRoom!==undefined){var g=t.dataset.galtRoom,gi=g.indexOf('|');setAltRoom(+g.slice(0,gi),g.slice(gi+1)||null);}
 else if(t.dataset.cdgo!==undefined){var ci=$('#dlk-code');if(ci)applyCode(ci.value);}
 else if(t.dataset.cdx!==undefined)clearCode();
 else if(t.dataset.cdok!==undefined)confirmCodeSwitch();
 else if(t.dataset.cdno!==undefined)cancelCodeSwitch();
 else if(t.dataset.zclear!==undefined)confirmClearAlts();
 else if(t.dataset.zundo!==undefined)undoAlts();
 else if(t.dataset.co!==undefined){if(zeroGate())return;location.href='/checkout';}
 else if(t.dataset.seg){var kv=t.dataset.seg.split('|'),box=t.closest('.fgrid');var inp=box.querySelector('[name="'+kv[0]+'"]');inp.value=kv[1];
  box.querySelectorAll('[data-seg^="'+kv[0]+'"]').forEach(function(x){x.classList.toggle('on',x===t);});
  var w=box.querySelector('.smw');if(w)w.hidden=inp.value!=='Ano';mntSave();}
 else if(t.id==='dlk-roomadd'){var inp2=$('#dlk-roomname');relines(function(){return addRoomAttr(inp2.value);});}
 else if(t.id==='dlk-mntchk'){$('#dlk-mntf').hidden=!t.checked;mntSave();}
});
document.addEventListener('input',function(e){if(e.target.closest&&e.target.closest('#dlk-mntf'))mntSave();});
document.addEventListener('change',function(e){if(e.target.closest&&e.target.closest('#dlk-mntf'))mntSave();});
document.addEventListener('keydown',function(e){
 if(e.target.id==='dlk-code'&&e.key==='Enter'){e.preventDefault();applyCode(e.target.value);}
 if(e.target.id==='dlk-roomname'&&e.key==='Enter'){e.preventDefault();$('#dlk-roomadd').click();}
 if(e.target.classList&&e.target.classList.contains('rnm')&&e.key==='Enter'){e.preventDefault();e.target.blur();}
 if(e.key==='Escape')closeAll();
});
document.addEventListener('blur',function(e){
 if(e.target.classList&&e.target.classList.contains('rnm')&&e.target.dataset.room)renameRoom(e.target.dataset.room,e.target.textContent);
},true);
/* drag & drop */
var dragKey=null,dragRoom=null;
document.addEventListener('dragstart',function(e){
 var rh=e.target.closest&&e.target.closest('.rhead[data-rdrag]');
 if(rh){dragRoom=rh.dataset.rdrag;e.dataTransfer.effectAllowed='move';try{e.dataTransfer.setData('text/plain',dragRoom);}catch(x){}return;}
 var ln=e.target.closest&&e.target.closest('.cline');if(!ln)return;
 dragKey=ln.dataset.key;ln.classList.add('dragging');
 e.dataTransfer.effectAllowed='move';try{e.dataTransfer.setData('text/plain',dragKey);}catch(x){}
});
document.addEventListener('dragend',function(){dragKey=null;dragRoom=null;root.querySelectorAll('.dragging,.dragover,.ins-t,.ins-b').forEach(function(el){el.classList.remove('dragging','dragover','ins-t','ins-b');});});
document.addEventListener('dragover',function(e){
 if(dragKey!==null){
  var ln=e.target.closest&&e.target.closest('.cline');
  if(ln&&ln.dataset.key!==dragKey){
   e.preventDefault();e.dataTransfer.dropEffect='move';
   var r=ln.getBoundingClientRect(),after=e.clientY>r.top+r.height/2;
   root.querySelectorAll('.ins-t,.ins-b').forEach(function(el){if(el!==ln)el.classList.remove('ins-t','ins-b');});
   ln.classList.toggle('ins-t',!after);ln.classList.toggle('ins-b',after);
   root.querySelectorAll('.rsec.dragover').forEach(function(el){el.classList.remove('dragover');});return;
  }
  root.querySelectorAll('.ins-t,.ins-b').forEach(function(el){el.classList.remove('ins-t','ins-b');});
 }
 var z=e.target.closest&&e.target.closest('.rsec');if(!z||(dragKey===null&&dragRoom===null))return;
 if(dragRoom!==null&&!z.dataset.drop)return;
 e.preventDefault();e.dataTransfer.dropEffect='move';
 root.querySelectorAll('.rsec.dragover').forEach(function(el){if(el!==z)el.classList.remove('dragover');});
 z.classList.add('dragover');
});
document.addEventListener('drop',function(e){
 if(dragRoom!==null){var zs=e.target.closest&&e.target.closest('.rsec');
  if(zs&&zs.dataset.drop){e.preventDefault();var dr=dragRoom;dragRoom=null;reorderRoom(dr,zs.dataset.drop);}return;}
 if(dragKey===null)return;
 var dk=dragKey;dragKey=null;
 var ln=e.target.closest&&e.target.closest('.cline');
 if(ln&&ln.dataset.key!==dk){
  e.preventDefault();
  var r=ln.getBoundingClientRect(),after=e.clientY>r.top+r.height/2;
  var ref=CART.items.find(function(x){return x.key===ln.dataset.key;});
  var room=roomsOn()?roomOf(ref):roomOf(CART.items.find(function(x){return x.key===dk;}));
  var ls=orderedLines(),refIdx=ls.findIndex(function(x){return x.key===ln.dataset.key;});
  var beforeKey=after?(ls[refIdx+1]?ls[refIdx+1].key:null):ln.dataset.key;
  relocate(dk,beforeKey,room);return;
 }
 var z=e.target.closest&&e.target.closest('.rsec');if(!z)return;
 e.preventDefault();assignRoom(dk,z.dataset.drop||null);
});
/* ---------- drawer ---------- */
function renderDrawer(){
 var d=$('#dlk-dlines');if(!d||!CART)return;
 var c=$('#dlk-dcount');if(c)c.textContent=plural(CART.item_count);
 renderHeaderCount();
 if(!CART.items.length)d.innerHTML='<div class="dempty">Košík je prázdný</div>';
 else d.innerHTML=orderedLines().map(function(l){
  return '<div class="dl">'+thm(l)+'<div class="mid">'+brandMarkOnly(l.vendor)+'<div class="nm">'+esc(l.product_title)+'</div>'+
  (l.variant_title?'<div class="vr">'+esc(l.variant_title)+'</div>':'')+
  (roomOf(l)?'<div class="rr">↳ '+esc(roomOf(l))+'</div>':'')+
  '<span class="qty"><button data-dec="'+esc(l.key)+'" aria-label="Méně">−</button><span>'+l.quantity+'</span><button data-inc="'+esc(l.key)+'" aria-label="Více">+</button></span></div>'+
  '<div class="end"><b>'+fmt(l.final_line_price)+'</b><button class="rm" data-rm="'+esc(l.key)+'">Odebrat</button></div></div>';}).join('');
 var sub=$('#dlk-dsub');if(sub)sub.textContent=fmt(CART.total_price);
 renderDrawerActions();
}
function renderDrawerActions(){
 var a=$('#dlk-dacts');if(!a)return;
 if(!CART.items.length){a.innerHTML='<a class="view" href="'+esc(conf.cartUrl||'/cart')+'">Zobrazit košík</a>';return;}
 var t=CART.total_price,h='',na=alts().length,dis=na?' disabled aria-disabled="true"':'';
 if(na)h+='<p class="zwarn">'+plural(na)+' s nulovým množstvím čeká na rozhodnutí v košíku.</p>';
 if(t>ORD_MAND)h+='<p class="ordnote">Nad '+fmt(ORD_MAND)+' vyřizujeme objednávky na fakturu</p>';
 else h+='<button class="co" data-dco'+dis+'>Pokračovat k pokladně</button>';
 if(t>=ORD_MIN)h+='<button class="ordbtn'+(t>ORD_MAND?' prime':'')+'" data-dord'+dis+'><b>Poslat objednávku</b><span class="sub">Na fakturu, bez okamžité platby</span></button>';
 h+='<a class="view" href="'+esc(conf.cartUrl||'/cart')+'">Zařadit do místností</a>';
 a.innerHTML=h;
}
document.addEventListener('click',function(e){
 var b=e.target.closest&&e.target.closest('[data-dco],[data-dord]');if(!b)return;
 e.preventDefault();
 if(zeroGate()){closeAll();return;}
 if(b.hasAttribute('data-dco')){location.href='/checkout';return;}
 /* the order popup needs the section settings, which only exist on the cart page */
 if(root&&D.orderPopup==='true'){closeAll();openOrder();}
 else{var u=conf.cartUrl||'/cart';location.href=u+(u.indexOf('?')>=0?'&':'?')+'ord=1';}
});
function openDrawer(){getCart().then(function(){renderDrawer();$('#dlk-dwr').classList.add('on');$('#dlk-ovl').classList.add('on');});}
function closeAll(){['#dlk-dwr','#dlk-ovl','#dlk-shm','#dlk-odm','#dlk-vm','#dlk-cf','#dlk-cfz'].forEach(function(s){var el=$(s);if(el)el.classList.remove('on');});}
document.addEventListener('click',function(e){
 if(e.target.closest&&e.target.closest('#dlk-dclose,#dlk-ovl'))closeAll();
 /* click the backdrop of any modal (not its card) to dismiss */
 var sh=e.target.closest&&e.target.closest('.dlk.shm');
 if(sh&&e.target===sh)closeAll();
});
/* capture phase + stopImmediatePropagation: the theme also binds the header cart icon to its
   own drawer, and preventDefault alone does not stop a second listener. One drawer only. */
document.addEventListener('click',function(e){
 var trg=e.target.closest&&e.target.closest('[data-cart-toggle]');
 if(!trg)return;
 if(location.pathname===(conf.cartUrl||'/cart'))return;
 e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
 openDrawer();
},true);
/* ---------- info markers, room dropdown, variant picker, delete confirm ---------- */
document.addEventListener('click',function(e){
 var t=e.target,inf=t.closest&&t.closest('.inf');
 document.querySelectorAll('.inf.on').forEach(function(x){if(x!==inf)x.classList.remove('on');});
 if(inf)inf.classList.toggle('on');
 var ddt=t.closest&&t.closest('[data-ddt]');
 document.querySelectorAll('.ddm:not([hidden])').forEach(function(m){
  if(!ddt||m.parentNode!==ddt.parentNode)m.hidden=true;
 });
 if(ddt){var mm=ddt.parentNode.querySelector('.ddm');if(mm)mm.hidden=!mm.hidden;}
 var vo=t.closest&&t.closest('[data-vopen]');
 if(vo)openVariants(vo.dataset.vopen);
});
var vsel={};
function openVariants(key){
 var l=CART.items.find(function(x){return x.key===key;});if(!l)return;
 var p=PRODUCTS[l.handle];
 if(!p||p==='pending'||!p.variants){toast('Načítám varianty, zkuste to za okamžik');return;}
 var m=$('#dlk-vm');
 if(!m){m=document.createElement('div');m.className='dlk shm';m.id='dlk-vm';document.body.appendChild(m);bindVariants(m);}
 vsel[key]=l.variant_id;m.dataset.key=key;
 var curV=p.variants.filter(function(x){return x.id===l.variant_id;})[0]||p.variants[0];
 var curImg=(curV&&curV.featured_image&&curV.featured_image.src)||p.featured_image||'';
 m.innerHTML='<div class="card"><button class="x" data-vx aria-label="Zavřít"><svg class="ic" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"></path></svg></button>'+
  '<h3>'+esc(l.product_title)+'</h3><p>Vyberte variantu. Můžete jí nahradit tuto položku, nebo ji přidat jako další.</p>'+
  '<div class="vwrap"><span class="vimg">'+(curImg?'<img src="'+esc(imgUrl(curImg,900))+'" alt="">':'')+'</span>'+
  '<div class="vlist">'+p.variants.map(function(x){
   var vi=(x.featured_image&&x.featured_image.src)||p.featured_image||'';
   return '<button class="vopt'+(x.id===l.variant_id?' on':'')+'"'+(x.available?'':' disabled')+' data-vpick="'+x.id+'"'+(vi?' data-vimg="'+esc(imgUrl(vi,900))+'"':'')+'>'+
    '<i class="dot"></i>'+
    '<span class="vn">'+esc(x.title)+'</span><span class="vp">'+fmt(x.price)+'</span>'+
    (x.available?'':'<span class="vna">Nedostupné</span>')+'</button>';
  }).join('')+'</div></div>'+
  '<div class="acts"><button class="cp" data-vrep>Nahradit položku</button><button class="nt" data-vadd>Přidat jako další</button><button class="nt" data-vx>Zpět</button></div>'+
  '<p class="hint"><a href="'+esc(l.url)+'">Otevřít celou stránku produktu →</a></p></div>';
 m.classList.add('on');$('#dlk-ovl').classList.add('on');
}
function bindVariants(m){
 m.addEventListener('click',function(e){
  if(e.target.closest('[data-vx]')){closeAll();return;}
  var pk=e.target.closest('[data-vpick]');
  if(pk){
   vsel[m.dataset.key]=+pk.dataset.vpick;
   m.querySelectorAll('[data-vpick]').forEach(function(x){x.classList.toggle('on',x===pk);});
   var im=m.querySelector('.vimg img');
   if(im&&pk.dataset.vimg&&im.getAttribute('src')!==pk.dataset.vimg)im.setAttribute('src',pk.dataset.vimg);
   return;}
  var rep2=e.target.closest('[data-vrep]'),add=e.target.closest('[data-vadd]');
  if(!rep2&&!add)return;
  var key=m.dataset.key,l=CART.items.find(function(x){return x.key===key;});
  if(!l){closeAll();return;}
  var vid=vsel[key]||l.variant_id;
  closeAll();
  if(rep2){setVariant(key,vid);return;}
  relines(function(){
   var it={id:vid,quantity:1,properties:{}};
   if(roomOf(l))it.properties[ROOM_KEY]=roomOf(l);
   if(lineIsPre(l))it.selling_plan=l.selling_plan_allocation.selling_plan.id;
   return addItem(it).then(function(){toast('Přidáno jako další položka');});
  });
 });
}
function confirmDelete(name){
 var m=$('#dlk-cf');
 if(!m){m=document.createElement('div');m.className='dlk shm';m.id='dlk-cf';document.body.appendChild(m);
  m.addEventListener('click',function(e){
   if(e.target.closest('[data-cfx]')){closeAll();return;}
   if(e.target.closest('[data-cfok]')){var n=m.dataset.room;closeAll();deleteRoom(n);}
  });}
 m.dataset.room=name;
 var n=CART.items.filter(function(l){return roomOf(l)===name;}).length;
 m.innerHTML='<div class="card"><h3>Zrušit místnost „'+esc(name)+'“?</h3>'+
  '<p>'+(n?'Zůstane v ní '+plural(n)+', přesuneme je do Nezařazeno. Z košíku se nic neodebere.':'Místnost je prázdná, nic se nepřesune.')+'</p>'+
  '<div class="acts"><button class="cp" data-cfok>Zrušit místnost</button><button class="nt" data-cfx>Ponechat</button></div></div>';
 m.classList.add('on');$('#dlk-ovl').classList.add('on');
}
/* The one gate. Every way out of the cart — the summary buttons, the drawer buttons, the ?ord=1
   deep link — asks this first, so a 0-qty tile can never be carried past the decision point.
   Returns true when the caller must stop. */
function zeroGate(){
 var n=alts().length;if(!n)return false;
 toast('Nejdřív rozhodněte o '+n+(n===1?' položce':' položkách')+' s nulovým množstvím');
 var z=root&&root.querySelector('.zwarn');
 if(z&&z.scrollIntoView)z.scrollIntoView({behavior:'smooth',block:'center'});
 return true;
}
function confirmClearAlts(){
 var m=$('#dlk-cfz');
 if(!m){m=document.createElement('div');m.className='dlk shm';m.id='dlk-cfz';document.body.appendChild(m);
  m.addEventListener('click',function(e){
   if(e.target.closest('[data-cfx]')){closeAll();return;}
   if(e.target.closest('[data-cfok]')){closeAll();clearAlts();}
  });}
 var n=alts().length;
 m.innerHTML='<div class="card"><h3>Odebrat '+plural(n)+' s nulovým množstvím?</h3>'+
  '<p>Z košíku zmizí všechny alternativy naráz. Hlavních výběrů se to nedotkne — a hned po odebrání se na stejném místě objeví <b>Vrátit zpět</b>, dokud neuděláte něco jiného.</p>'+
  '<div class="acts"><button class="cp" data-cfok>Odebrat '+n+'</button><button class="nt" data-cfx>Ponechat</button></div></div>';
 m.classList.add('on');$('#dlk-ovl').classList.add('on');
}
/* ---------- share + QR + toast ---------- */
function toast(msg){var t=$('#dlk-toast');if(!t)return;t.textContent=msg;t.classList.add('on');clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('on');},2200);}
function openShare(){
 var url=buildShareLink();
 if(navigator.share){navigator.share({title:'design—light · košík',url:url}).catch(function(){copyShare(url);});}
 else copyShare(url);
}
function copyShare(url){
 (navigator.clipboard?navigator.clipboard.writeText(url):Promise.reject()).then(function(){toast('Odkaz zkopírován, pošlete ho klientovi');},function(){window.prompt('Zkopírujte odkaz:',url);});
}
/* ---------- draft order popup (only when enable_order_popup) ---------- */
document.addEventListener('click',function(e){
 var b=e.target.closest&&e.target.closest('[data-ord]');if(!b)return;
 if(D.orderPopup==='true')openOrder();
 /* else: existing dl-order.js owns [data-ord] — see BINDINGS */
});
function openOrder(){
 if(zeroGate())return;
 var m=$('#dlk-odm');
 if(!m){m=document.createElement('div');m.className='dlk shm';m.id='dlk-odm';m.innerHTML=orderModalHTML();document.body.appendChild(m);bindOrder(m);}
 var rc=rooms().filter(function(r){return CART.items.some(function(l){return roomOf(l)===r;});}).length;
 $('#dlk-odrecap',m).innerHTML='<span>'+plural(CART.item_count)+'</span>'+(rc?'<span>'+rc+(rc===1?' místnost':rc<5?' místnosti':' místností')+'</span>':'')+'<span>'+fmt(CART.total_price)+'</span>'+(mntOn()?'<span>Montáž: Ano</span>':'');
 $('#dlk-odmz',m).innerHTML=montBlockHTML();
 $('#dlk-odform',m).hidden=false;$('#dlk-oddone',m).hidden=true;
 m.classList.add('on');$('#dlk-ovl').classList.add('on');
}
function montBlockHTML(){
 var a=CART.attributes,on=mntOn(),oad=addrSplit(a[MNT_MAP.minst]);
 return '<div class="odmz"><label class="mntg"><input type="checkbox" id="dlk-odmnt"'+(on?' checked':'')+'> Mám zájem o montáž</label>'+
 '<p class="hint">Instalace našimi techniky, nezávazně. Cenovou nabídku pošleme zvlášť.</p>'+
 '<div class="fgrid" id="dlk-odmntf"'+(on?'':' hidden')+'>'+
 '<label class="full">Ulice a číslo *<input data-oaddr="u" type="text" placeholder="Sázavská 2031/32" value="'+esc(oad.u)+'"></label>'+
 '<label>PSČ *<input data-oaddr="p" type="text" inputmode="numeric" maxlength="6" placeholder="120 00" value="'+esc(oad.p)+'"></label>'+
 '<label>Město *<input data-oaddr="m" type="text" placeholder="Praha" value="'+esc(oad.m)+'"></label>'+
 '<label>Výška stropu<input data-omz="mstrop" type="text" placeholder="např. 2,7 m" value="'+esc(a[MNT_MAP.mstrop])+'"></label>'+
 '<label>Materiál stropu<input data-omz="mmat" type="text" placeholder="nevím" list="dlk-mmats" value="'+esc(a[MNT_MAP.mmat])+'"></label>'+
 '<label>Smart home<span class="seg segf"><button type="button" class="sg'+(a[MNT_MAP.msmart]==='Ano'?'':' on')+'" data-oseg="msmart|Ne">Ne</button><button type="button" class="sg'+(a[MNT_MAP.msmart]==='Ano'?' on':'')+'" data-oseg="msmart|Ano">Ano</button></span><input type="hidden" data-omz="msmart" value="'+esc(a[MNT_MAP.msmart]||'Ne')+'"></label>'+
 '<label class="osmw"'+(a[MNT_MAP.msmart]==='Ano'?'':' hidden')+'>Který systém<input data-omz="msmartw" type="text" placeholder="např. Loxone, KNX" value="'+esc(a[MNT_MAP.msmartw])+'"></label>'+
 '<label>Termín<input data-omz="mtermin" type="date" value="'+esc(a[MNT_MAP.mtermin])+'"></label>'+
 '<div class="full checks">'+
 '<label class="chk"><input type="checkbox" data-omz="mdemont"'+(a[MNT_MAP.mdemont]==='Ano'?' checked':'')+'> Demontáž stávajících svítidel</label>'+
 '<label class="chk"><input type="checkbox" data-omz="mlikvid"'+(a[MNT_MAP.mlikvid]==='Ano'?' checked':'')+'> Likvidace stávajících svítidel</label></div>'+
 '<label class="full">Poznámka<textarea data-omz="mpozn" rows="2" placeholder="přístup, počet svítidel, přání k termínu">'+esc(a[MNT_MAP.mpozn])+'</textarea></label></div></div>';
}
/* montáž as edited INSIDE the popup; master key matches the live contract (§2.3) */
function collectMont(m){
 var c=$('#dlk-odmnt',m);if(!c||!c.checked)return null;
 var out={};out['Montáž']=MNT_ON;
 Object.keys(MNT_MAP).forEach(function(k){
  var el=m.querySelector('[data-omz="'+k+'"]');if(!el)return;
  out[MNT_MAP[k]]=el.type==='checkbox'?(el.checked?'Ano':''):el.value;
 });
 /* v1.4.0: stejná pravidla jako v košíkovém formuláři — složená adresa a jednotka u výšky.
    KOSIK_ODKAZ se sem ZÁMĚRNĚ nepřidává: tenhle objekt jde jako `montaz` do `order-request`
    a validaci té funkce jsme neprověřili. Neregistrovaný klíč na cestě nad 80 000 Kč, kde je
    to jediný způsob, jak zaplatit, nestojí za to riziko. Odkaz na draft doplníme, až se
    `order-request` rozšíří (§2.8). Do košíkových atributů ho píše syncCartLink(). */
 var oa=function(n){var el=m.querySelector('[data-oaddr="'+n+'"]');return el?el.value:'';};
 out[MNT_MAP.minst]=addrJoin(oa('u'),oa('p'),oa('m'));
 out[MNT_MAP.mstrop]=normCeil(out[MNT_MAP.mstrop]);
 out['Montáž - odstranění stávajících']=legacyOdstr(out[MNT_MAP.mdemont],out[MNT_MAP.mlikvid]);
 return out;
}
function orderModalHTML(){
 return '<div class="card"><button class="x" data-odx aria-label="Zavřít"><svg class="ic" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"></path></svg></button>'+
 '<div id="dlk-odform"><h3>Poslat objednávku</h3><p>Na fakturu, bez okamžité platby. Objednávku připravíme a ozveme se s platebními údaji, faktura dorazí e-mailem.</p>'+
 '<div class="recap" id="dlk-odrecap"></div>'+
 '<form id="dlk-odf" novalidate><input class="hp" name="hp" type="text" tabindex="-1" autocomplete="off" aria-hidden="true">'+
 '<div class="fgrid">'+
 '<label>Jméno *<input name="jmeno" type="text" autocomplete="name"></label>'+
 '<label>E-mail *<input name="email" type="email" autocomplete="email"></label>'+
 '<label>Firma / IČ<input name="firma" type="text"></label>'+
 '<label>Telefon<input name="telefon" type="tel" autocomplete="tel"></label>'+
 '<label class="full">Ulice a číslo *<input name="street" type="text" autocomplete="street-address"></label>'+
 '<label>Město *<input name="city" type="text" autocomplete="address-level2"></label>'+
 '<label>PSČ *<input name="zip" type="text" autocomplete="postal-code"></label>'+
 '<label>Země<span class="seg segf"><button type="button" class="sg on" data-cty="CZ">CZ</button><button type="button" class="sg" data-cty="SK">SK</button></span><input type="hidden" name="country" value="CZ"></label>'+
 '<label>Urgence dodání<input name="urgence" type="date"></label>'+
 '<label>Urgence poznámka<input name="urgpozn" type="text"></label></div>'+
 '<div id="dlk-odmz"></div>'+
 '<p class="ferr" id="dlk-oderr" hidden>Vyplňte prosím jméno, e-mail a doručovací adresu.</p>'+
 '<div class="acts"><button class="cp" type="submit">Poslat objednávku</button><button class="nt" type="button" data-odx>Zpět do košíku</button></div></form></div>'+
 '<div id="dlk-oddone" hidden><h3>Objednávku jsme přijali</h3><div class="dnum" id="dlk-odnum"></div><p>Ozveme se s platebními údaji, faktura dorazí e-mailem. Košík zůstává, můžete ho dál upravovat.</p><div class="acts"><button class="nt" data-odx>Zavřít</button></div></div></div>';
}
function bindOrder(m){
 m.addEventListener('click',function(e){
  if(e.target.closest('[data-odx]'))closeAll();
  var c=e.target.closest('[data-cty]');
  if(c){m.querySelector('[name=country]').value=c.dataset.cty;m.querySelectorAll('[data-cty]').forEach(function(x){x.classList.toggle('on',x===c);});}
  if(e.target.id==='dlk-odmnt'){$('#dlk-odmntf',m).hidden=!e.target.checked;}
  var g=e.target.closest('[data-oseg]');
  if(g){var kv=g.dataset.oseg.split('|');m.querySelector('[data-omz="'+kv[0]+'"]').value=kv[1];
   m.querySelectorAll('[data-oseg^="'+kv[0]+'"]').forEach(function(x){x.classList.toggle('on',x===g);});
   var w=m.querySelector('.osmw');if(w)w.hidden=kv[1]!=='Ano';}
 });
 $('#dlk-odf',m).addEventListener('submit',function(e){
  e.preventDefault();var f=e.target;if(f.hp.value)return;
  var bad=[];
  ['jmeno','email','street','city','zip'].forEach(function(n){f[n].classList.remove('err');});
  if(!f.jmeno.value.trim())bad.push(f.jmeno);
  if(!/.+@.+\..+/.test(f.email.value))bad.push(f.email);
  ['street','city','zip'].forEach(function(n){if(!f[n].value.trim())bad.push(f[n]);});
  if(bad.length){bad.forEach(function(x){x.classList.add('err');});$('#dlk-oderr',m).hidden=false;bad[0].focus();return;}
  $('#dlk-oderr',m).hidden=true;
  var btn=f.querySelector('.cp');btn.disabled=true;btn.textContent='Odesílám…';
  var mnt=collectMont(m);
  fetch(D.orderEndpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(buildOrderPayload(f,mnt))})
   .then(function(r){return r.json();})
   .then(function(res){
    if(!res||res.ok!==true)throw res;
    if(mnt)updateAttrs(mnt).then(getCart).catch(function(){});
    $('#dlk-odnum',m).textContent=res.draftOrderName||'';
    $('#dlk-odform',m).hidden=true;$('#dlk-oddone',m).hidden=false;
   })
   .catch(function(res){toast((res&&res.error)||'Odeslání se nepodařilo, zkuste to prosím znovu nebo volejte 602 360 300');})
   .then(function(){btn.disabled=false;btn.textContent='Poslat objednávku';});
 });
}
/* Payload = LIVE edge-function contract (dl-order.js rev 5.2, v1.2.1) + planned extensions
   sellingPlan + properties whitelist (PREREQUISITES §2). OPEN for cowork: confirm montaz
   subkey names + token semantics against dl-order.js rev 5.2 before deploy. */
function buildOrderPayload(f,montaz){
 return {
  items:orderedLines().map(function(l){
   var it={variantId:l.variant_id,quantity:l.quantity};
   if(lineIsPre(l))it.sellingPlan=l.selling_plan_allocation.selling_plan.id;
   if(roomOf(l))it.properties={'Místnost':roomOf(l)};
   return it;
  }),
  customer:{
   name:f.jmeno.value.trim(),
   company:f.firma.value.trim(),
   email:f.email.value.trim(),
   phone:f.telefon.value.trim(),
   street:f.street.value.trim(),
   city:f.city.value.trim(),
   zip:f.zip.value.trim(),
   country:f.country.value
  },
  urgency:{date:f.urgence.value,note:f.urgpozn.value.trim()},
  montaz:montaz,
  attributes:{'Místnosti':rooms().join('|')},
  token:Date.now().toString(36)+Math.random().toString(36).slice(2,10),
  hp:f.hp.value
 };
}
/* ---------- product page: edit-a-cart-line bar (opened by the cart's Varianta button) ---------- */
function editKey(){try{return new URLSearchParams(location.search).get('dlk')||'';}catch(x){return '';}}
function curVariantId(){
 var i=document.querySelector('form[data-type="add-to-cart-form"] input[name="id"],form[action*="/cart/add"] input[name="id"]');
 if(i&&i.value)return +i.value;
 var j=document.querySelector('[data-selected-variant]');
 if(j){try{var v=JSON.parse(j.textContent);if(v&&v.id)return +v.id;}catch(x){}}
 return 0;
}
function mountEditBar(){
 var key=editKey();if(!key||!CART||document.getElementById('dlk-edit'))return;
 var l=CART.items.find(function(x){return x.key===key;});if(!l)return;
 var anchor=document.querySelector('.product-form__buttons')||document.querySelector('.product-form');
 if(!anchor)return;
 anchor.insertAdjacentHTML('beforebegin',
  '<div class="dlk dlk-edit" id="dlk-edit"><div class="eb">'+
  '<span class="m">Upravujete položku z košíku</span>'+
  '<b>'+esc(l.product_title)+(roomOf(l)?' · '+esc(roomOf(l)):'')+'</b>'+
  '<span class="sp"></span>'+
  '<button type="button" class="sg on" data-dlk-replace>Nahradit položku</button>'+
  '<button type="button" class="sg" data-dlk-add>Přidat jako další</button>'+
  '<a class="sg" href="'+esc(conf.cartUrl||'/cart')+'">Zpět do košíku</a>'+
  '</div></div>');
}
document.addEventListener('click',function(e){
 var r=e.target.closest&&e.target.closest('[data-dlk-replace],[data-dlk-add]');if(!r)return;
 e.preventDefault();
 var back=conf.cartUrl||'/cart';
 var l=CART&&CART.items.find(function(x){return x.key===editKey();});
 if(!l){location.href=back;return;}
 var vid=curVariantId();
 if(!vid){toast('Vyberte prosím variantu');return;}
 var replace=r.hasAttribute('data-dlk-replace');
 if(replace&&vid===l.variant_id){location.href=back;return;}
 r.disabled=true;
 /* add first, remove the old line only after it succeeds — a rejected add can never lose the item */
 var it={id:vid,quantity:replace?l.quantity:1,properties:{}};
 if(roomOf(l))it.properties[ROOM_KEY]=roomOf(l);
 if(lineIsPre(l))it.selling_plan=l.selling_plan_allocation.selling_plan.id;
 addItem(it)
  .then(function(){return replace?change(l.key,0):null;})
  .then(function(){location.href=back;})
  .catch(function(err){r.disabled=false;toast((err&&err.description)||'Položku se nepodařilo upravit');});
});
/* the theme re-renders the buy-button block on variant change — re-inject if it vanishes */
function observeEditBar(){
 var host=document.getElementById('MainContent')||document.body,t;
 new MutationObserver(function(){clearTimeout(t);t=setTimeout(mountEditBar,120);}).observe(host,{childList:true,subtree:true});
}
/* ---------- boot ---------- */
getCart().then(function(){
 if(root){
  render();
  try{if(new URLSearchParams(location.search).get('ord')&&D.orderPopup==='true')openOrder();}catch(x){}
 }
 else{renderDrawer();if(editKey()){mountEditBar();observeEditBar();}}
});
/* ---------- public API + PDP add to cart (2026-08-10) ----------
   The PDP buy form is <form id="dl-buy" class="dl-buyform"> in sections/dl-product-main.liquid.
   It used to POST natively to /cart/add, so Shopify answered with a redirect and the customer
   lost the product page. Now we POST to /cart/add.js and open this file's mini drawer instead.

   Why the binding lives here and not in dl-product.js:
     - openDrawer/getCart/renderDrawer/toast are private to this IIFE, so the same-file binding
       needs no global and no load-order luck;
     - dl-product.js is a deferred <head> script (snippets/dl-assets.liquid) while this file is a
       deferred script at the end of <body>. Deferred scripts run in document order, so
       dl-product.js executes FIRST and window.DLK_CART would not yet exist at its bind time;
     - dl-product.js loads only on template.name == 'product'; this file loads everywhere;
     - the listener is delegated on document, so it survives the buy block being re-rendered.
   Rollback = delete this block and the renderHeaderCount() call inside renderDrawer(). */
function renderHeaderCount(){
 /* header badge is <cart-count class="n"> inside .navx-util (sections/dl-header-b.liquid);
    it is server-rendered with [hidden] at zero, so toggle that as well as the text.
    Fully defensive: the header is absent on password and checkout pages. */
 try{
  var n=CART?CART.item_count:0,els=document.querySelectorAll('.navx-util .n');
  for(var i=0;i<els.length;i++){
   els[i].textContent=String(n);
   if(n)els[i].removeAttribute('hidden');else els[i].setAttribute('hidden','');
  }
 }catch(e){}
}
/* Explicit API, so a caller never has to synthesise a click on [data-cart-toggle].
   open() re-reads /cart.js itself (see openDrawer), which is why the add handler below calls it
   directly instead of refresh()+open() - that would be two round trips for one add.
   refresh() is for callers that want the counts updated WITHOUT opening the drawer.
   Note it deliberately does not re-render the cart page board: nothing calls it from /cart today,
   and render() there interacts with the in-flight (busy) machinery. */
window.DLK_CART={
 open:function(){openDrawer();},
 /* CHANGED 2026-09-02: refresh used to repaint only the drawer and the header count, so anything
    added from outside this file — the „+" in the search takeover — was invisible to someone
    standing ON the cart page until they reloaded. render() repaints the board and calls
    renderDrawer() itself; off-cart it detects the missing #dlk-app and falls back to the drawer,
    so this one call is correct on every template. */
 refresh:function(){return getCart().then(function(){if(!busy)render();renderHeaderCount();});},
 toast:function(m){toast(m);}
};
document.addEventListener('submit',function(e){
 var f=e.target;
 if(!f||!f.matches||!f.matches('form#dl-buy,form.dl-buyform'))return;
 e.preventDefault();
 if(f.getAttribute('data-dlk-busy'))return;          /* ignore double submits while in flight */
 f.setAttribute('data-dlk-busy','1');
 var btn=f.querySelector('[data-dl-submit]')||f.querySelector('button[type="submit"]');
 /* dl-product.js drives btn.disabled from variant availability, so restore whatever it was
    rather than force-enabling a sold-out variant back to life. */
 var was=btn?btn.disabled:false;
 if(btn){btn.disabled=true;btn.classList.add('is-loading');btn.setAttribute('aria-busy','true');}
 var done=function(){
  f.removeAttribute('data-dlk-busy');
  if(btn){btn.disabled=was;btn.classList.remove('is-loading');btn.removeAttribute('aria-busy');}
 };
 /* FormData carries id, quantity and - when dl-product.js has enabled it - selling_plan, which
    is how the preorder plan reaches the cart. That input ships disabled and disabled controls are
    omitted from FormData natively, so the plan rides along exactly when it applies, never else. */
 fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(f)})
  .then(function(r){
   return r.json().then(function(j){return{ok:r.ok,body:j};},function(){return{ok:r.ok,body:null};});
  })
  .then(function(res){
   if(!res.ok){var err=new Error('cart/add failed');err.body=res.body;throw err;}
   done();
   if($('#dlk-dwr'))openDrawer();else window.DLK_CART.refresh();
  })
  .catch(function(err){
   done();
   var msg=err&&err.body&&(err.body.description||err.body.message);
   /* Never swallow the failure. Show what Shopify said (422 out of stock etc.); if there is
      nothing showable - network drop, opaque error, or no toast node on the page - fall back to
      the plain native POST so the customer is never left with a dead button. */
   if(msg&&$('#dlk-toast')){toast(msg);return;}
   try{f.submit();}catch(x){}   /* form.submit() does not fire submit, so this cannot recurse */
  });
});
})();